import React, { useState } from 'react';
import map from '../../assets/img/map-new.jpg'
import ranhgioi from '../../assets/img/anh-chi-tiet.jpg'
import quyhoach from '../../assets/img/anh-quy-hoach.png'
import ketnoi from '../../assets/img/ha-tang-ket-noi.png'
import './DatDaiLand.css';

function DatDaiLand () {
     const [isShowModal, setIsShowModal] = useState(false);
  const [showDetailPage, setShowDetailPage] = useState(false);



//   Nhiều tab
 const [khuDatDetailCurrentPage, setKhuDatDetailCurrentPage] = useState("detail");
 const [activeTab, setActiveTab] = useState("detail");



    // Start  Hàm thêm khu đất đai
 const handleOpenModal = () => {
    setIsShowModal(true);
  };

  const handleCloseModal = () => {
    setIsShowModal(false);
  };

   const saveModal = () => {
    setIsShowModal(false);
  };
// End hàm thêm khu đất đai





//   nhiều tab
// Hàm mở tab chi tiết đất đai
 const handleOpenDetail = () => {
    setShowDetailPage(true);
  };
// đóng chi tiết đất đai
  const handleCloseDetail = () => {
    setShowDetailPage(false);
  };

// mở tab ranh giới 
    const handleOpenMapPage = () => {
        setKhuDatDetailCurrentPage("boundary");
         setActiveTab("boundary")
    };

    // mở tab pháp lý
     const handleShowLegal = () => {
    setKhuDatDetailCurrentPage("legal");
     setActiveTab("legal")
  };


// hàm mở tab quy hoạch
  const handleShowPlanning = () => {
    setKhuDatDetailCurrentPage("planning")
    setActiveTab("planning")
    console.log("đi vào đấy")
  }

  //hàm mở tab hạ tầng kết nối connect
  const handleShowConnect = () => {
    setKhuDatDetailCurrentPage("connect")
    setActiveTab("connect")
    console.log("đi vào đấy")
  }

  //hàm mở doanh nghiệp thuê đất

  const handleShowBusinesses = () => {
    setKhuDatDetailCurrentPage("businesses")
    setActiveTab("businesses")
    console.log("đi vào đấy")
  }


  const handleShowHistory = () => {
    setKhuDatDetailCurrentPage("history")
    setActiveTab("history")
    console.log("đi vào đấy")
  }





    // quay lại tab detal
    const khuDatDetailGoBackPage = () => {
        // window.history.back();
        setKhuDatDetailCurrentPage("detail")
         if (khuDatDetailCurrentPage === "legal") {
      setKhuDatDetailCurrentPage("detail");
    } else if (setKhuDatDetailCurrentPage === "boundary") {
      setKhuDatDetailCurrentPage("detail");
      
    }
    else if (setKhuDatDetailCurrentPage === "planning") {
      setKhuDatDetailCurrentPage("detail");
      
    }

     else if (setKhuDatDetailCurrentPage === "connect") {
      setKhuDatDetailCurrentPage("detail");
      
    }

    else if (setKhuDatDetailCurrentPage === "businesses") {
      setKhuDatDetailCurrentPage("detail");
      
    }

     else if (setKhuDatDetailCurrentPage === "history") {
      setKhuDatDetailCurrentPage("detail");
      
    }
  
    };

    const khuDatDetailCloseBoundaryPage = () => {
        setKhuDatDetailCurrentPage("detail");
        setActiveTab("detail")
    };
        return (
 <div className="tong-quan-dat-dai-wrapper">

        {/* <!-- Breadcrumb --> */}
        <div className="tong-quan-breadcrumb-container">
            <div className="tong-quan-breadcrumb-left">
                <span className="tong-quan-breadcrumb-home">Trang chủ</span>
                <span className="tong-quan-breadcrumb-arrow">›</span>
                <span className="tong-quan-breadcrumb-middle">Đất đai</span>
                <span className="tong-quan-breadcrumb-arrow">›</span>
                <span className="tong-quan-breadcrumb-current">Tổng quan</span>
            </div>

            <div className="tong-quan-breadcrumb-right">
                <button className="tong-quan-bao-cao-button">
                    <span className="tong-quan-bao-cao-icon">
                        <i className="fa-regular fa-file icon-share-land"></i>
                        {/* 📄 */}
                        </span>
                    Báo cáo đất đai
                </button>

                <button className="tong-quan-them-khu-dat-button" onClick={handleOpenModal}>
                    <span className="tong-quan-them-khu-dat-icon icon-share-land">
                        <i className="fa-solid fa-plus"></i>
                        {/* ＋ */}
                        </span>
                    Thêm khu đất
                </button>
            </div>
        </div>

        {/* <!-- Title --> */}
        <div className="tong-quan-title-container">
            <h1 className="tong-quan-main-title">Quản lý đất đai</h1>
        </div>

        {/* <!-- Statistic Cards --> */}
        <div className="tong-quan-statistic-card-row">

            <div className="tong-quan-statistic-card-item">
                <div className="tong-quan-statistic-card-icon tong-quan-statistic-card-icon-purple">
                    🗺
                </div>

                <div className="tong-quan-statistic-card-content">
                    <div className="tong-quan-statistic-card-label">
                        Tổng diện tích đất
                    </div>

                    <div className="tong-quan-statistic-card-value">
                        1.234,56 ha
                    </div>

                    <div className="tong-quan-statistic-card-percent">
                        100% diện tích KKT
                    </div>
                </div>
            </div>

            <div className="tong-quan-statistic-card-item">
                <div className="tong-quan-statistic-card-icon tong-quan-statistic-card-icon-green">
                    📄
                </div>

                <div className="tong-quan-statistic-card-content">
                    <div className="tong-quan-statistic-card-label">
                        Đất đã cho thuê
                    </div>

                    <div className="tong-quan-statistic-card-value">
                        856,32 ha
                    </div>

                    <div className="tong-quan-statistic-card-percent">
                        69,32%
                    </div>
                </div>
            </div>

            <div className="tong-quan-statistic-card-item">
                <div className="tong-quan-statistic-card-icon tong-quan-statistic-card-icon-orange">
                    📈
                </div>

                <div className="tong-quan-statistic-card-content">
                    <div className="tong-quan-statistic-card-label">
                        Đất còn trống
                    </div>

                    <div className="tong-quan-statistic-card-value">
                        278,24 ha
                    </div>

                    <div className="tong-quan-statistic-card-percent">
                        22,55%
                    </div>
                </div>
            </div>

            <div className="tong-quan-statistic-card-item">
                <div className="tong-quan-statistic-card-icon tong-quan-statistic-card-icon-pink">
                    ⏱
                </div>

                <div className="tong-quan-statistic-card-content">
                    <div className="tong-quan-statistic-card-label">
                        Đang trong quy hoạch
                    </div>

                    <div className="tong-quan-statistic-card-value">
                        100,00 ha
                    </div>

                    <div className="tong-quan-statistic-card-percent">
                        8,10%
                    </div>
                </div>
            </div>

        </div>

        {/* <!-- Chart Row --> */}
        <div className="tong-quan-chart-main-row tong-quan-chart-main-row-responsive ">

            {/* <!-- Pie Chart --> */}
            <div className="tong-quan-pie-chart-card">

                <div className="tong-quan-chart-title-row">
                    <div className="tong-quan-chart-title-left">
                        Diện tích đất theo loại đất
                    </div>

                    <div className="tong-quan-chart-title-right">
                        Đơn vị: ha
                    </div>
                </div>

                <div className="tong-quan-pie-chart-body">

                    <div className="tong-quan-pie-chart-circle">
                        <div className="tong-quan-pie-chart-inner-circle">
                            <div className="tong-quan-pie-chart-inner-value">
                                1.234,56
                            </div>

                            <div className="tong-quan-pie-chart-inner-unit">
                                ha
                            </div>
                        </div>
                    </div>

                    <div className="tong-quan-pie-chart-legend-wrapper">

                        <div className="tong-quan-pie-chart-legend-item">
                            <div className="tong-quan-pie-chart-legend-color tong-quan-pie-chart-legend-blue"></div>

                            <div className="tong-quan-pie-chart-legend-text">
                                <div className="tong-quan-pie-chart-legend-title">
                                    Đất công nghiệp
                                </div>

                                <div className="tong-quan-pie-chart-legend-value">
                                    856,32 ha (69,32%)
                                </div>
                            </div>
                        </div>

                        <div className="tong-quan-pie-chart-legend-item">
                            <div className="tong-quan-pie-chart-legend-color tong-quan-pie-chart-legend-orange"></div>

                            <div className="tong-quan-pie-chart-legend-text">
                                <div className="tong-quan-pie-chart-legend-title">
                                    Đất dịch vụ - thương mại
                                </div>

                                <div className="tong-quan-pie-chart-legend-value">
                                    156,45 ha (12,67%)
                                </div>
                            </div>
                        </div>

                        <div className="tong-quan-pie-chart-legend-item">
                            <div className="tong-quan-pie-chart-legend-color tong-quan-pie-chart-legend-yellow"></div>

                            <div className="tong-quan-pie-chart-legend-text">
                                <div className="tong-quan-pie-chart-legend-title">
                                    Đất hạ tầng kỹ thuật
                                </div>

                                <div className="tong-quan-pie-chart-legend-value">
                                    98,75 ha (8,00%)
                                </div>
                            </div>
                        </div>

                        <div className="tong-quan-pie-chart-legend-item">
                            <div className="tong-quan-pie-chart-legend-color tong-quan-pie-chart-legend-green"></div>

                            <div className="tong-quan-pie-chart-legend-text">
                                <div className="tong-quan-pie-chart-legend-title">
                                    Đất cây xanh - mặt nước
                                </div>

                                <div className="tong-quan-pie-chart-legend-value">
                                    78,56 ha (6,36%)
                                </div>
                            </div>
                        </div>

                        <div className="tong-quan-pie-chart-legend-item">
                            <div className="tong-quan-pie-chart-legend-color tong-quan-pie-chart-legend-purple"></div>

                            <div className="tong-quan-pie-chart-legend-text">
                                <div className="tong-quan-pie-chart-legend-title">
                                    Đất khác
                                </div>

                                <div className="tong-quan-pie-chart-legend-value">
                                    44,48 ha (3,65%)
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            {/* <!-- Column Chart --> */}
            <div className="tong-quan-column-chart-card">

                <div className="tong-quan-chart-title-row">
                    <div className="tong-quan-chart-title-left">
                        Tình hình sử dụng đất theo năm
                    </div>

                    <div className="tong-quan-chart-title-right">
                        Đơn vị: ha
                    </div>
                </div>

                <div className="tong-quan-column-chart-wrapper">

                    <div className="tong-quan-column-chart-left-labels">
                        <span>1000</span>
                        <span>800</span>
                        <span>600</span>
                        <span>400</span>
                        <span>200</span>
                        <span>0</span>
                    </div>

                    <div className="tong-quan-column-chart-center">

                        <div className="tong-quan-column-chart-grid-line"></div>
                        <div className="tong-quan-column-chart-grid-line"></div>
                        <div className="tong-quan-column-chart-grid-line"></div>
                        <div className="tong-quan-column-chart-grid-line"></div>
                        <div className="tong-quan-column-chart-grid-line"></div>

                        <div className="tong-quan-column-chart-bars-row">

                            <div className="tong-quan-column-chart-item">
                                <div className="tong-quan-column-chart-bar-group">
                                    <div className="tong-quan-column-chart-blue-bar tong-quan-column-chart-blue-bar-2022">
                                        <span className="tong-quan-column-chart-blue-value">
                                            620,45
                                        </span>
                                    </div>

                                    <div className="tong-quan-column-chart-green-line-point tong-quan-column-chart-green-line-point-1">
                                        <span className="tong-quan-column-chart-line-percent">
                                            50,28%
                                        </span>
                                    </div>
                                </div>

                                <div className="tong-quan-column-chart-year">
                                    2022
                                </div>
                            </div>

                            <div className="tong-quan-column-chart-item">
                                <div className="tong-quan-column-chart-bar-group">
                                    <div className="tong-quan-column-chart-blue-bar tong-quan-column-chart-blue-bar-2023">
                                        <span className="tong-quan-column-chart-blue-value">
                                            704,32
                                        </span>
                                    </div>

                                    <div className="tong-quan-column-chart-green-line-point tong-quan-column-chart-green-line-point-2">
                                        <span className="tong-quan-column-chart-line-percent">
                                            57,05%
                                        </span>
                                    </div>
                                </div>

                                <div className="tong-quan-column-chart-year">
                                    2023
                                </div>
                            </div>

                            <div className="tong-quan-column-chart-item">
                                <div className="tong-quan-column-chart-bar-group">
                                    <div className="tong-quan-column-chart-blue-bar tong-quan-column-chart-blue-bar-2024">
                                        <span className="tong-quan-column-chart-blue-value">
                                            782,16
                                        </span>
                                    </div>

                                    <div className="tong-quan-column-chart-green-line-point tong-quan-column-chart-green-line-point-3">
                                        <span className="tong-quan-column-chart-line-percent">
                                            63,35%
                                        </span>
                                    </div>
                                </div>

                                <div className="tong-quan-column-chart-year">
                                    2024
                                </div>
                            </div>

                            <div className="tong-quan-column-chart-item">
                                <div className="tong-quan-column-chart-bar-group">
                                    <div className="tong-quan-column-chart-blue-bar tong-quan-column-chart-blue-bar-2025">
                                        <span className="tong-quan-column-chart-blue-value">
                                            812,28
                                        </span>
                                    </div>

                                    <div className="tong-quan-column-chart-green-line-point tong-quan-column-chart-green-line-point-4">
                                        <span className="tong-quan-column-chart-line-percent">
                                            65,82%
                                        </span>
                                    </div>
                                </div>

                                <div className="tong-quan-column-chart-year">
                                    2025
                                </div>
                            </div>

                            <div className="tong-quan-column-chart-item">
                                <div className="tong-quan-column-chart-bar-group">
                                    <div className="tong-quan-column-chart-blue-bar tong-quan-column-chart-blue-bar-2026">
                                        <span className="tong-quan-column-chart-blue-value">
                                            856,32
                                        </span>
                                    </div>

                                    <div className="tong-quan-column-chart-green-line-point tong-quan-column-chart-green-line-point-5">
                                        <span className="tong-quan-column-chart-line-percent">
                                            69,32%
                                        </span>
                                    </div>
                                </div>

                                <div className="tong-quan-column-chart-year">
                                    2026
                                </div>
                            </div>

                        </div>

                        <div className="tong-quan-column-chart-green-line-wrapper">
                            <div className="tong-quan-column-chart-green-line-segment tong-quan-column-chart-green-line-segment-1"></div>
                            <div className="tong-quan-column-chart-green-line-segment tong-quan-column-chart-green-line-segment-2"></div>
                            <div className="tong-quan-column-chart-green-line-segment tong-quan-column-chart-green-line-segment-3"></div>
                            <div className="tong-quan-column-chart-green-line-segment tong-quan-column-chart-green-line-segment-4"></div>
                        </div>

                    </div>

                    <div className="tong-quan-column-chart-right-labels">
                        <span>100%</span>
                        <span>80%</span>
                        <span>60%</span>
                        <span>40%</span>
                        <span>20%</span>
                        <span>0%</span>
                    </div>

                </div>

            </div>

            {/* <!-- Progress Chart --> */}
            <div className="tong-quan-progress-chart-card">

                <div className="tong-quan-chart-title-row">
                    <div className="tong-quan-chart-title-left">
                        Phân bố diện tích theo khu công nghiệp
                    </div>
                </div>

                <div className="tong-quan-progress-chart-wrapper">

                    <div className="tong-quan-progress-chart-item">
                        <div className="tong-quan-progress-chart-top">
                            <span className="tong-quan-progress-chart-name">
                                KCN Bình Hòa
                            </span>

                            <span className="tong-quan-progress-chart-value">
                                412,35 ha (33,39%)
                            </span>
                        </div>

                        <div className="tong-quan-progress-chart-bar-bg">
                            <div className="tong-quan-progress-chart-bar-fill tong-quan-progress-chart-bar-fill-1"></div>
                        </div>
                    </div>

                    <div className="tong-quan-progress-chart-item">
                        <div className="tong-quan-progress-chart-top">
                            <span className="tong-quan-progress-chart-name">
                                KCN Vĩnh Thạnh
                            </span>

                            <span className="tong-quan-progress-chart-value">
                                298,20 ha (24,14%)
                            </span>
                        </div>

                        <div className="tong-quan-progress-chart-bar-bg">
                            <div className="tong-quan-progress-chart-bar-fill tong-quan-progress-chart-bar-fill-2"></div>
                        </div>
                    </div>

                    <div className="tong-quan-progress-chart-item">
                        <div className="tong-quan-progress-chart-top">
                            <span className="tong-quan-progress-chart-name">
                                KCN Tân Trung
                            </span>

                            <span className="tong-quan-progress-chart-value">
                                251,60 ha (20,37%)
                            </span>
                        </div>

                        <div className="tong-quan-progress-chart-bar-bg">
                            <div className="tong-quan-progress-chart-bar-fill tong-quan-progress-chart-bar-fill-3"></div>
                        </div>
                    </div>

                    <div className="tong-quan-progress-chart-item">
                        <div className="tong-quan-progress-chart-top">
                            <span className="tong-quan-progress-chart-name">
                                KCN Bình Long
                            </span>

                            <span className="tong-quan-progress-chart-value">
                                172,45 ha (13,97%)
                            </span>
                        </div>

                        <div className="tong-quan-progress-chart-bar-bg">
                            <div className="tong-quan-progress-chart-bar-fill tong-quan-progress-chart-bar-fill-4"></div>
                        </div>
                    </div>

                    <div className="tong-quan-progress-chart-item">
                        <div className="tong-quan-progress-chart-top">
                            <span className="tong-quan-progress-chart-name">
                                KCN Thanh Lộc
                            </span>

                            <span className="tong-quan-progress-chart-value">
                                100,00 ha (8,10%)
                            </span>
                        </div>

                        <div className="tong-quan-progress-chart-bar-bg">
                            <div className="tong-quan-progress-chart-bar-fill tong-quan-progress-chart-bar-fill-5"></div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        {/* <!-- Table --> */}
        <div className="tong-quan-table-card">

            <div className="tong-quan-table-title">
                Danh sách khu đất
            </div>

            {/* <!-- Filter --> */}
            <div className="tong-quan-filter-row">

                <div className="tong-quan-filter-item">
                    <label className="tong-quan-filter-label">
                        Khu công nghiệp
                    </label>

                    <select className="tong-quan-filter-select">
                        <option>Tất cả</option>
                    </select>
                </div>

                <div className="tong-quan-filter-item">
                    <label className="tong-quan-filter-label">
                        Loại đất
                    </label>

                    <select className="tong-quan-filter-select">
                        <option>Tất cả</option>
                    </select>
                </div>

                <div className="tong-quan-filter-item">
                    <label className="tong-quan-filter-label">
                        Tình trạng sử dụng
                    </label>

                    <select className="tong-quan-filter-select">
                        <option>Tất cả</option>
                    </select>
                </div>

                <div className="tong-quan-filter-item">
                    <label className="tong-quan-filter-label">
                        Hiện trạng pháp lý
                    </label>

                    <select className="tong-quan-filter-select">
                        <option>Tất cả</option>
                    </select>
                </div>

                <div className="tong-quan-filter-search-wrapper">
                    <label className="tong-quan-filter-label">
                        Tìm kiếm khu đất
                    </label>

                    <input
                        type="text"
                        className="tong-quan-filter-search-input"
                        placeholder="Nhập tên khu đất, mã lô, tờ bản đồ..."
                    />
                </div>

                <div className="tong-quan-filter-button-group">
                    <button className="tong-quan-lam-moi-button">
                        ↻ Làm mới
                    </button>

                    <button className="tong-quan-bo-loc-button">
                        Bộ lọc
                    </button>
                </div>

            </div>

            {/* <!-- Table --> */}
            <div className="tong-quan-table-responsive">

                <table className="tong-quan-data-table">

                    <thead className="tong-quan-data-table-head">
                        <tr className="tong-quan-data-table-head-row">
                            <th className="tong-quan-data-table-head-cell">STT</th>
                            <th className="tong-quan-data-table-head-cell">Tên khu đất</th>
                            <th className="tong-quan-data-table-head-cell">KCN</th>
                            <th className="tong-quan-data-table-head-cell">Loại đất</th>
                            <th className="tong-quan-data-table-head-cell">Diện tích (ha)</th>
                            <th className="tong-quan-data-table-head-cell">Diện tích đã cho thuê (ha)</th>
                            <th className="tong-quan-data-table-head-cell">Diện tích còn trống (ha)</th>
                            <th className="tong-quan-data-table-head-cell">Tỷ lệ lấp đầy</th>
                            <th className="tong-quan-data-table-head-cell">Trạng thái pháp lý</th>
                            <th className="tong-quan-data-table-head-cell">Tình trạng sử dụng</th>
                            <th className="tong-quan-data-table-head-cell">Thao tác</th>
                        </tr>
                    </thead>

                    <tbody className="tong-quan-data-table-body">

                        <tr className="tong-quan-data-table-body-row">
                            <td className="tong-quan-data-table-body-cell">1</td>
                            <td className="tong-quan-data-table-body-cell">Lô CN-01</td>
                            <td className="tong-quan-data-table-body-cell">KCN Bình Hòa</td>
                            <td className="tong-quan-data-table-body-cell">Đất công nghiệp</td>
                            <td className="tong-quan-data-table-body-cell">50,00</td>
                            <td className="tong-quan-data-table-body-cell">42,50</td>
                            <td className="tong-quan-data-table-body-cell">7,50</td>
                            <td className="tong-quan-data-table-body-cell">85,00%</td>
                            <td className="tong-quan-data-table-body-cell">Đã có GCNQSDĐ</td>
                            <td className="tong-quan-data-table-body-cell">
                                <span className="tong-quan-table-status-active">
                                    Đang sử dụng
                                </span>
                            </td>
                            <td className="tong-quan-data-table-body-cell">
                                  <i className="fa-solid fa-eye icon-actiton-table"  onClick={handleOpenDetail}></i>
                                <i className="fa-solid fa-pen icon-actiton-table"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-actiton-table"></i>
                            </td>
                        </tr>

                        <tr className="tong-quan-data-table-body-row">
                            <td className="tong-quan-data-table-body-cell">2</td>
                            <td className="tong-quan-data-table-body-cell">Lô CN-02</td>
                            <td className="tong-quan-data-table-body-cell">KCN Bình Hòa</td>
                            <td className="tong-quan-data-table-body-cell">Đất công nghiệp</td>
                            <td className="tong-quan-data-table-body-cell">35,00</td>
                            <td className="tong-quan-data-table-body-cell">35,00</td>
                            <td className="tong-quan-data-table-body-cell">0,00</td>
                            <td className="tong-quan-data-table-body-cell">100,00%</td>
                            <td className="tong-quan-data-table-body-cell">Đã có GCNQSDĐ</td>
                            <td className="tong-quan-data-table-body-cell">
                                <span className="tong-quan-table-status-active">
                                    Đã cho thuê
                                </span>
                            </td>
                             <td className="tong-quan-data-table-body-cell">
                                <i className="fa-solid fa-eye icon-actiton-table" onClick={handleOpenDetail}></i>
                                <i className="fa-solid fa-pen icon-actiton-table"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-actiton-table"></i>
                                {/* 👁 ✎ ⋮ */}
                                </td>
                        </tr>

                        <tr className="tong-quan-data-table-body-row">
                            <td className="tong-quan-data-table-body-cell">3</td>
                            <td className="tong-quan-data-table-body-cell">Lô DV-01</td>
                            <td className="tong-quan-data-table-body-cell">KCN Vĩnh Thạnh</td>
                            <td className="tong-quan-data-table-body-cell">Đất dịch vụ - TM</td>
                            <td className="tong-quan-data-table-body-cell">20,00</td>
                            <td className="tong-quan-data-table-body-cell">12,00</td>
                            <td className="tong-quan-data-table-body-cell">8,00</td>
                            <td className="tong-quan-data-table-body-cell">60,00%</td>
                            <td className="tong-quan-data-table-body-cell">Đã có GCNQSDĐ</td>
                            <td className="tong-quan-data-table-body-cell">
                                <span className="tong-quan-table-status-active">
                                    Đang sử dụng
                                </span>
                            </td>
                            <td className="tong-quan-data-table-body-cell">
                                <i className="fa-solid fa-eye icon-actiton-table"  onClick={handleOpenDetail}></i>
                                <i className="fa-solid fa-pen icon-actiton-table"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-actiton-table"></i>
                                {/* 👁 ✎ ⋮ */}
                                </td>
                        </tr>

                        <tr className="tong-quan-data-table-body-row">
                            <td className="tong-quan-data-table-body-cell">4</td>
                            <td className="tong-quan-data-table-body-cell">Lô HTKT-01</td>
                            <td className="tong-quan-data-table-body-cell">KCN Tân Trung</td>
                            <td className="tong-quan-data-table-body-cell">Đất hạ tầng kỹ thuật</td>
                            <td className="tong-quan-data-table-body-cell">15,50</td>
                            <td className="tong-quan-data-table-body-cell">15,50</td>
                            <td className="tong-quan-data-table-body-cell">0,00</td>
                            <td className="tong-quan-data-table-body-cell">100,00%</td>
                            <td className="tong-quan-data-table-body-cell">Đã có GCNQSDĐ</td>
                            <td className="tong-quan-data-table-body-cell">
                                <span className="tong-quan-table-status-active">
                                    Đang sử dụng
                                </span>
                            </td>
                            <td className="tong-quan-data-table-body-cell">
                                  <i className="fa-solid fa-eye icon-actiton-table"  onClick={handleOpenDetail}></i>
                                <i className="fa-solid fa-pen icon-actiton-table"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-actiton-table"></i>
                                {/* 👁 ✎ ⋮ */}
                                </td>
                        </tr>

                        <tr className="tong-quan-data-table-body-row">
                            <td className="tong-quan-data-table-body-cell">5</td>
                            <td className="tong-quan-data-table-body-cell">Lô CX-01</td>
                            <td className="tong-quan-data-table-body-cell">KCN Bình Long</td>
                            <td className="tong-quan-data-table-body-cell">Đất cây xanh - mặt nước</td>
                            <td className="tong-quan-data-table-body-cell">12,30</td>
                            <td className="tong-quan-data-table-body-cell">0,00</td>
                            <td className="tong-quan-data-table-body-cell">12,30</td>
                            <td className="tong-quan-data-table-body-cell">0,00%</td>
                            <td className="tong-quan-data-table-body-cell">Quy hoạch</td>
                            <td className="tong-quan-data-table-body-cell">
                                <span className="tong-quan-table-status-planning">
                                    Trong quy hoạch
                                </span>
                            </td>
                            <td className="tong-quan-data-table-body-cell">
                                  <i className="fa-solid fa-eye icon-actiton-table"  onClick={handleOpenDetail}></i>
                                <i className="fa-solid fa-pen icon-actiton-table"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-actiton-table"></i>
                                {/* 👁 ✎ ⋮ */}
                                </td>
                        </tr>

                    </tbody>

                </table>

            </div>

            {/* <!-- Pagination --> */}
            <div className="tong-quan-pagination-wrapper">

                <div className="tong-quan-pagination-left-land">
                    Hiển thị 1 - 5 trong tổng số 25 khu đất
                </div>

                <div className="tong-quan-pagination-right">

                    <div className="tong-quan-pagination-page-size">
                        5 / trang
                    </div>

                    <button className="tong-quan-pagination-arrow">
                        ‹
                    </button>

                    <button className="tong-quan-pagination-number tong-quan-pagination-number-active">
                        1
                    </button>

                    <button className="tong-quan-pagination-number">
                        2
                    </button>

                    <button className="tong-quan-pagination-number">
                        3
                    </button>

                    <button className="tong-quan-pagination-number">
                        ...
                    </button>

                    <button className="tong-quan-pagination-number">
                        5
                    </button>

                    <button className="tong-quan-pagination-arrow">
                        ›
                    </button>

                </div>

            </div>

        </div>











        {/* VÙNG MODAL */}
                   {isShowModal && (
        <div className="quan-ly-dat-dai-modal-overlay">
          <div className="quan-ly-dat-dai-modal-container">
            <div className="quan-ly-dat-dai-modal-header">
              <h3 className="quan-ly-dat-dai-modal-title">Thêm khu đất</h3>

              <button
                className="quan-ly-dat-dai-modal-close-button"
                onClick={handleCloseModal}
              >
                ×
              </button>
            </div>

            <div className="quan-ly-dat-dai-modal-body">
              <div className="quan-ly-dat-dai-section-title">
                Thông tin chung
              </div>

              <div className="quan-ly-dat-dai-form-grid">
                <div className="quan-ly-dat-dai-form-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Tên khu đất
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <input
                    type="text"
                    className="quan-ly-dat-dai-input"
                    placeholder="Nhập tên khu đất"
                  />
                </div>

                <div className="quan-ly-dat-dai-form-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Mã khu đất
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <input
                    type="text"
                    className="quan-ly-dat-dai-input"
                    placeholder="Nhập mã khu đất"
                  />
                </div>

                <div className="quan-ly-dat-dai-form-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Khu công nghiệp
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>Chọn khu công nghiệp</option>
                  </select>
                </div>

                <div className="quan-ly-dat-dai-form-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Loại đất
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>Chọn loại đất</option>
                  </select>
                </div>

                <div className="quan-ly-dat-dai-form-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Tình trạng sử dụng
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>Chọn tình trạng sử dụng</option>
                  </select>
                </div>

                <div className="quan-ly-dat-dai-form-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Mục đích sử dụng
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>Chọn mục đích sử dụng</option>
                  </select>
                </div>
              </div>

              <div className="quan-ly-dat-dai-section-title">
                Thông tin diện tích
              </div>

              <div className="quan-ly-dat-dai-area-grid">
                <div className="quan-ly-dat-dai-area-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Diện tích đất
                  </label>

                  <div className="quan-ly-dat-dai-input-unit-wrapper">
                    <input
                      type="text"
                      className="quan-ly-dat-dai-input-unit"
                      placeholder="Nhập diện tích"
                    />

                    <span className="quan-ly-dat-dai-unit-text">ha</span>
                  </div>
                </div>

                <div className="quan-ly-dat-dai-area-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Diện tích đã cho thuê (ha)
                  </label>

                  <div className="quan-ly-dat-dai-input-unit-wrapper">
                    <input
                      type="text"
                      className="quan-ly-dat-dai-input-unit"
                      placeholder="Nhập diện tích"
                    />

                    <span className="quan-ly-dat-dai-unit-text">ha</span>
                  </div>
                </div>

                <div className="quan-ly-dat-dai-area-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Diện tích còn trống (ha)
                  </label>

                  <div className="quan-ly-dat-dai-input-unit-wrapper">
                    <input
                      type="text"
                      className="quan-ly-dat-dai-input-unit"
                      placeholder="Nhập diện tích"
                    />

                    <span className="quan-ly-dat-dai-unit-text">ha</span>
                  </div>
                </div>

                <div className="quan-ly-dat-dai-area-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Tỷ lệ lấp đầy (%)
                  </label>

                  <div className="quan-ly-dat-dai-input-unit-wrapper">
                    <input
                      type="text"
                      className="quan-ly-dat-dai-input-unit"
                      placeholder="Nhập tỷ lệ"
                    />

                    <span className="quan-ly-dat-dai-unit-text">%</span>
                  </div>
                </div>
              </div>

              <div className="quan-ly-dat-dai-section-title">Vị trí</div>

              <div className="quan-ly-dat-dai-address-grid">
                <div className="quan-ly-dat-dai-address-full">
                  <label className="quan-ly-dat-dai-form-label">
                    Địa chỉ
                  </label>

                  <input
                    type="text"
                    className="quan-ly-dat-dai-input"
                    placeholder="Nhập địa chỉ"
                  />
                </div>

                <div className="quan-ly-dat-dai-address-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Xã/Phường
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>Chọn xã/phường</option>
                  </select>
                </div>

                <div className="quan-ly-dat-dai-address-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Huyện/Thị xã/Thành phố
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>Chọn huyện/thị xã/thành phố</option>
                  </select>
                </div>

                <div className="quan-ly-dat-dai-address-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Tỉnh/Thành phố
                    <span className="quan-ly-dat-dai-required">*</span>
                  </label>

                  <select className="quan-ly-dat-dai-select">
                    <option>An Giang</option>
                  </select>
                </div>
              </div>

              <div className="quan-ly-dat-dai-map-search">
                <label className="quan-ly-dat-dai-form-label">
                  Bản đồ vị trí
                </label>

                <input
                  type="text"
                  className="quan-ly-dat-dai-map-input"
                  placeholder="Nhập địa điểm tìm vị trí"
                />
              </div>

              <div className="quan-ly-dat-dai-map-box">
                {/* <div className="quan-ly-dat-dai-map-marker"></div> */}

                <button className="quan-ly-dat-dai-map-zoom-in">+</button>

                <button className="quan-ly-dat-dai-map-zoom-out">−</button>
              </div>

              <div className="quan-ly-dat-dai-section-title">
                Thông tin bổ sung
              </div>

              <div className="quan-ly-dat-dai-extra-grid">
                <div className="quan-ly-dat-dai-extra-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Quyết định/Thông báo
                  </label>

                  <input
                    type="text"
                    className="quan-ly-dat-dai-input"
                    placeholder="Nhập số quyết định"
                  />
                </div>

                <div className="quan-ly-dat-dai-extra-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Ngày ban hành
                  </label>

                  <input
                    type="date"
                    className="quan-ly-dat-dai-input"
                  />
                </div>

                <div className="quan-ly-dat-dai-extra-item">
                  <label className="quan-ly-dat-dai-form-label">
                    Ghi chú
                  </label>

                  <textarea
                    className="quan-ly-dat-dai-textarea"
                    placeholder="Nhập ghi chú (nếu có)"
                  >

                   
                  </textarea>
                   <span className='value-text-control'>0/500</span>
                </div>
              </div>
            </div>

            <div className="quan-ly-dat-dai-modal-footer">
              <button
                className="quan-ly-dat-dai-cancel-button"
                onClick={handleCloseModal}
              >
                Hủy
              </button>

              <button className="quan-ly-dat-dai-save-button" onClick={saveModal}>
                Lưu
              </button>
            </div>
          </div>
        </div>
      )}
        {/* MODAL */}




























































        {/* VÙNG CHI TIẾT KHU ĐẤT */}
   <div
            className={`khu-dat-detail-page ${
              showDetailPage
                ? "khu-dat-detail-page-show"
                : ""
            }`}
          >
            {/* BREADCRUMB */}
            <div className="khu-dat-detail-breadcrumb">
                <i className="fa-solid fa-house icon-housse"></i>
              Trang chủ &gt; Đất đai &gt; Quản lý đất đai &gt;
              Chi tiết khu đất
            </div>

             <div className="khu-dat-detail-main-title">
                  Chi tiết khu đất
                </div>


                 
               
                    <div className='button-actions-click'>

              <div className="khu-dat-detail-left-title">
                <button
                  className="khu-dat-detail-back-button"
                  onClick={() =>
                    handleCloseDetail(false)
                  }
                >
                  <i className="fa-solid fa-arrow-left icon-back-page"></i>
                   Quay lại
                </button>

              
              </div>
              

              <div className="khu-dat-detail-action-group">
                <button className="khu-dat-detail-edit-button ">
                    <i className="fa-solid fa-pen icon-back-page"></i>
                  Chỉnh sửa
                </button>

                <button className="khu-dat-detail-pdf-button">
                    <i className="fa-regular fa-file-pdf icon-back-page"></i>
                  Xuất PDF
                </button>

                <select className="khu-dat-detail-more-button">
                  <option>Khác</option>
                </select>
              </div>
                    </div>

                
            {/* TITLE */}
            <div className="khu-dat-detail-top">
             
            </div>

            {/* THÔNG TIN + MAP */}
<div className="land-information-wrapper">
    <div className="land-information-left">
        <div className="land-information-title">
            Thông tin chung
        </div>

        <div className="land-information-content">
            <div className="land-information-column-one">
                <div className="land-information-row-one">
                    <div className="land-information-label-one">Tên khu đất</div>
                    <div className="land-information-colon-one">:</div>
                    <div className="land-information-value-one">Lô CN-01</div>
                </div>

                <div className="land-information-row-two">
                    <div className="land-information-label-two">Mã khu đất</div>
                    <div className="land-information-colon-two">:</div>
                    <div className="land-information-value-two">AG-KCNBH-CN01</div>
                </div>

                <div className="land-information-row-three">
                    <div className="land-information-label-three">Khu công nghiệp</div>
                    <div className="land-information-colon-three">:</div>
                    <div className="land-information-value-three">KCN Bình Hòa</div>
                </div>

                <div className="land-information-row-four">
                    <div className="land-information-label-four">Loại đất</div>
                    <div className="land-information-colon-four">:</div>
                    <div className="land-information-value-four">Đất công nghiệp</div>
                </div>

                <div className="land-information-row-five">
                    <div className="land-information-label-five">Diện tích</div>
                    <div className="land-information-colon-five">:</div>
                    <div className="land-information-value-five">50,00 ha</div>
                </div>

                <div className="land-information-row-six">
                    <div className="land-information-label-six">Diện tích đã cho thuê</div>
                    <div className="land-information-colon-six">:</div>
                    <div className="land-information-value-six">42,50 ha (85,00%)</div>
                </div>

                <div className="land-information-row-seven">
                    <div className="land-information-label-seven">Diện tích còn trống</div>
                    <div className="land-information-colon-seven">:</div>
                    <div className="land-information-value-seven">7,50 ha (15,00%)</div>
                </div>

                <div className="land-information-row-eight">
                    <div className="land-information-label-eight">Hiện trạng pháp lý</div>
                    <div className="land-information-colon-eight">:</div>
                    <div className="land-information-value-eight">Đã có GCNQSDĐ</div>
                </div>

                <div className="land-information-row-nine">
                    <div className="land-information-label-nine">Mục đích sử dụng</div>
                    <div className="land-information-colon-nine">:</div>
                    <div className="land-information-value-nine">Đất xây dựng nhà máy, kho tàng</div>
                </div>

                <div className="land-information-row-ten">
                    <div className="land-information-label-ten">Thời hạn sử dụng</div>
                    <div className="land-information-colon-ten">:</div>
                    <div className="land-information-value-ten">Đến 15/07/2060</div>
                </div>

                <div className="land-information-row-eleven">
                    <div className="land-information-label-eleven">Nguồn gốc sử dụng</div>
                    <div className="land-information-colon-eleven">:</div>
                    <div className="land-information-value-eleven">
                        Nhà nước cho thuê đất trả tiền hằng năm
                    </div>
                </div>
            </div>

            <div className="land-information-column-two">
                <div className="land-information-row-twelve">
                    <div className="land-information-label-twelve">Địa chỉ</div>
                    <div className="land-information-colon-twelve">:</div>
                    <div className="land-information-value-twelve">
                        KCN Bình Hòa, huyện Châu Thành, tỉnh An Giang
                    </div>
                </div>

                <div className="land-information-row-thirteen">
                    <div className="land-information-label-thirteen">Tọa độ (tâm điểm)</div>
                    <div className="land-information-colon-thirteen">:</div>
                    <div className="land-information-value-thirteen">
                        10.567890, 105.456789
                    </div>
                </div>

                <div className="land-information-row-fourteen">
                    <div className="land-information-label-fourteen">Đơn vị quản lý</div>
                    <div className="land-information-colon-fourteen">:</div>
                    <div className="land-information-value-fourteen">
                        Ban quản lý KKT tỉnh An Giang
                    </div>
                </div>

                <div className="land-information-row-fifteen">
                    <div className="land-information-label-fifteen">Tình trạng sử dụng</div>
                    <div className="land-information-colon-fifteen">:</div>
                    <div className="land-information-value-fifteen">
                        <span className="land-information-status-one">
                            Đang sử dụng
                        </span>
                    </div>
                </div>

                <div className="land-information-row-sixteen">
                    <div className="land-information-label-sixteen">Trạng thái khu đất</div>
                    <div className="land-information-colon-sixteen">:</div>
                    <div className="land-information-value-sixteen">
                        <span className="land-information-status-two">
                            Đang khai thác
                        </span>
                    </div>
                </div>

                <div className="land-information-row-seventeen">
                    <div className="land-information-label-seventeen">Ngày tạo</div>
                    <div className="land-information-colon-seventeen">:</div>
                    <div className="land-information-value-seventeen">
                        10/01/2023
                    </div>
                </div>

                <div className="land-information-row-eighteen">
                    <div className="land-information-label-eighteen">Ngày cập nhật</div>
                    <div className="land-information-colon-eighteen">:</div>
                    <div className="land-information-value-eighteen">
                        10/05/2026 10:30
                    </div>
                </div>

                <div className="land-information-row-nineteen">
                    <div className="land-information-label-nineteen">Người cập nhật</div>
                    <div className="land-information-colon-nineteen">:</div>
                    <div className="land-information-value-nineteen">
                        Nguyễn Văn A
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="land-location-wrapper">
        <div className="land-location-header">
            <div className="land-location-title">
                Vị trí khu đất
            </div>

            <div className="land-location-view">
                Xem bản đồ lớn
            </div>
        </div>

        <div className="land-location-map">
            <img
                className="land-location-image"
                src={map}
                alt=""
            />
           
        </div>
         <div className='button-icon-view-map'>
                <button className='btn-fa-plus'>
                    <i className="fa-solid fa-plus"></i>
                </button>
                <button className='btn-fa-minus'>
                  <i className="fa-solid fa-minus"></i>
                </button>
                <button className='btn-fa-crosshairs'>
                    <i className="fa-solid fa-location-crosshairs"></i>
                </button>
            </div>


        <div className="land-location-note">
            <i className="fa-solid fa-circle-exclamation icon-exclamation-detail"></i>
            Nhấn vào bản đồ để xem thông tin chi tiết ranh giới
        </div>
    </div>
</div>

            {/* End thông tin + map */}

            {/* TAB */}
            <div className="khu-dat-detail-tab-wrapper">

              <div className="khu-dat-detail-tab-item khu-dat-detail-tab-item-active">
                Thông tin chi tiết
              </div>

              <div className="khu-dat-detail-tab-item" onClick={handleOpenMapPage}>
                Ranh giới & Bản đồ
              </div>

              <div className="khu-dat-detail-tab-item" onClick={handleShowLegal}>
                Pháp lý
              </div>

              <div className="khu-dat-detail-tab-item" onClick={handleShowPlanning}>
                Quy hoạch
              </div>

              <div className="khu-dat-detail-tab-item" onClick={handleShowConnect}>
                Hạ tầng & Kết nối
              </div>

              <div className="khu-dat-detail-tab-item" onClick={handleShowBusinesses}>
                Doanh nghiệp thuê đất
              </div>

              <div className="khu-dat-detail-tab-item" onClick={handleShowHistory}>
                Lịch sử biến động
              </div>
            </div>

            {/* 3 CARD */}
            <div className="khu-dat-detail-card-row">

              {/* QUY HOẠCH */}
              <div className="khu-dat-detail-small-card">

                <div className="khu-dat-detail-small-title">
                  Thông tin quy hoạch
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Quy hoạch phân khu</span>
                  <span>Phân khu KCN Bình Hòa</span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Chức năng sử dụng đất </span>
                  <span>Đất công nghiệp</span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Hệ số sử dụng đất</span>
                  <span>≤ 2.0 lần</span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Mật độ xây dựng </span>
                  <span>≤ 60%</span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Chiều cao công trình</span>
                  <span>≤ 40m</span>
                </div>

                  <div className="khu-dat-detail-small-item">
                  <span>Khoảng lùi xây dựng</span>
                  <span>Theo quy định QH chi tiết</span>
                </div>

                   <div className="khu-dat-detail-small-item">
                  <span>Ghi chú quy hoạch</span>
                  <span>-</span>
                </div>
              </div>

              {/* HẠ TẦNG */}
              <div className="khu-dat-detail-small-card">

                <div className="khu-dat-detail-small-title">
                  Tiện ích & Hạ tầng
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Đường giao thông</span>
                  <span>
                    Đường nội bộ 22m, kết nối QL91
                  </span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Cấp điện</span>
                  <span>
                    Trạm 110kV Bình Hòa
                  </span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Cấp nước</span>
                  <span>
                    Nhà máy nước Bình Hòa
                  </span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>PCCC</span>
                  <span>
                    Trạm PCCC chuyên dụng KCN
                  </span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Viễn thông</span>
                  <span>
                    Đầy đủ VNPT, Viettel, FPT
                  </span>
                </div>

                  <div className="khu-dat-detail-small-item">
                  <span>Khoảng cách đến cảng</span>
                  <span>
                    Cảng Quốc tế Long Xuyên 12 km
                  </span>
                </div>

                <div className="khu-dat-detail-small-item">
                  <span>Khoảng cách đến sân bay</span>
                  <span>
                    Sân bay Cần thơ 85 km
                  </span>
                </div>

              </div>

              {/* FILE */}
              <div className="khu-dat-detail-small-card">

                <div className="khu-dat-detail-small-title">
                   
                  Tệp đính kèm
                </div>

                <div className="khu-dat-detail-file-item">
                    <div className='list-file'>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                            <i class="fa-regular fa-file-pdf icon-pdf-listttt"></i>
                          Giấy chứng nhận QSDĐ.pdf</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                        
                          1.25MB</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li  className='list-file-item'>  
                           <i class="fa-solid fa-download"></i>
                           </li>
                         
                        </ul>
                    </div>
                </div>

                <div className="khu-dat-detail-file-item">
                     <div className='list-file'>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                            <i class="fa-regular fa-file-pdf icon-pdf-listttt"></i>
                             Bản đồ quy hoạch /2000.pdf</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                        
                         2.45MB</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li  className='list-file-item'>  
                           <i class="fa-solid fa-download"></i>
                           </li>
                         
                        </ul>
                    </div>
              
                </div>

                <div className="khu-dat-detail-file-item">
                       <div className='list-file'>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                            <i class="fa-regular fa-file-pdf icon-pdf-listttt"></i>
                               Quyết định giao đất.pdf</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                        
                       1.18MB</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li  className='list-file-item'>  
                           <i class="fa-solid fa-download"></i>
                           </li>
                         
                        </ul>
                    </div>
               
                </div>

                <div className="khu-dat-detail-file-item">
                     <div className='list-file'>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                            <i className="fa-regular fa-file-zipper icon-zippp"></i>
                                Hồ sơ pháp lý.zip</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li className='list-file-item'>  
                        
                       8.75MB</li>
                        </ul>
                        <ul className='list-file-list'>
                           <li  className='list-file-item'>  
                           <i class="fa-solid fa-download"></i>
                           </li>
                         
                        </ul>
                    </div>
                
                </div>

                  <div className='view-all'>
                <button className='view-all-btn'>Xem tất cả</button>
              </div>
              </div>
            
            </div>

            {/* TABLE */}
            <div className="khu-dat-detail-bottom-table-card">

              <div className="khu-dat-detail-bottom-title">
                Doanh nghiệp đang thuê đất
              </div>

              <div className="khu-dat-detail-bottom-table-wrapper">

                <table className="khu-dat-detail-bottom-table">

                  <thead>
                    <tr>
                      <th>STT</th>
                      <th>Tên doanh nghiệp</th>
                      <th>Diện tích thuê</th>
                      <th>Thời hạn thuê</th>
                      <th>Ngày bắt đầu</th>
                      <th>Ngày hết hạn</th>
                      <th>Tình trạng</th>
                      <th>Hợp đồng</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Công ty TNHH An Giang Garment</td>
                      <td>20,00</td>
                      <td>10 năm</td>
                      <td>15/07/2020</td>
                      <td>14/07/2030</td>
                      <td>Đang thuê</td>
                      <td>HDTD-AGG-2020-001</td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td>Công ty CP Cơ khí Chính xác AG</td>
                      <td>12,50</td>
                      <td>15 năm</td>
                      <td>09/03/2019</td>
                      <td>28/02/2034</td>
                      <td>Đang thuê</td>
                      <td>HDTD-CKCX-2019-002</td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td>Công ty TNHH Điện tử AG</td>
                      <td>10,00</td>
                      <td>20 năm</td>
                      <td>10/11/2021</td>
                      <td>09/11/2041</td>
                      <td>Đang thuê</td>
                      <td>HDTD-DT-2021-003</td>
                    </tr>
                  </tbody>

                </table>


    
              </div>
                          <div className="pagination-wrapper-detail">

    <div className="pagination-container">

      <div className="pagination-text">
        Hiển thị 1 - 3 trong tổng số 3 doanh nghiệp
      </div>

      <div className="pagination-right">

        <select className="pagination-select">
          <option>5 / trang</option>
          <option>10 / trang</option>
          <option>20 / trang</option>
        </select>

        <div className="pagination-buttons">

          <button className="pagination-arrow-button">
            &#8249;
          </button>

          <button className="pagination-number-button">
            1
          </button>

          <button className="pagination-arrow-button">
            &#8250;
          </button>

        </div>

      </div>

    </div>

  </div>
            </div>

          </div>
        {/* VÙNG CHI TIẾT KHU ĐẤT */}






















 



        {/* Ranh giới & bản đồ */}
          <div
                className={
                    khuDatDetailCurrentPage === "boundary"
                        ? "khu-dat-boundary-overlay-show"
                        : "khu-dat-boundary-overlay-hide"
                }
            >
                <div className="khu-dat-boundary-container">
                    {/* Header */}
                    <div className="khu-dat-boundary-header-wrapper">
                        <div className="khu-dat-boundary-header-left">
                            <button
                                className="khu-dat-boundary-back-button"
                                type="button"
                                onClick={khuDatDetailGoBackPage}
                            >
                                ← Quay lại
                            </button>

                        </div>
                         

                        <div className="khu-dat-boundary-header-right">
                            <button
                                className="khu-dat-boundary-edit-button"
                                type="button"
                            >
                                Chỉnh sửa
                            </button>

                            <button
                                className="khu-dat-boundary-export-button"
                                type="button"
                            >
                                Xuất PDF
                            </button>

                            <button
                                className="khu-dat-boundary-more-button"
                                type="button"
                            >
                                Khác
                            </button>
                        </div>
                    </div>

                       <h2 className="khu-dat-boundary-title">
                                Chi tiết khu đất: Lô CN-01
                            </h2>
                    {/* Tabs */}
                    <div className="khu-dat-boundary-tab-wrapper">
                        <button 
                   className={`khu-dat-boundary-tab-item ${
                    activeTab === "detail"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={khuDatDetailCloseBoundaryPage}
                        >
                            Thông tin chi tiết
                        </button>

                        <button
                         className={`khu-dat-boundary-tab-item ${
                    activeTab === "boundary"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                           
                            type="button"
                             onClick={() => setActiveTab("boundary")}
                        >
                            Ranh giới &amp; Bản đồ
                        </button>

                        <button
                          className={`khu-dat-boundary-tab-item ${
                    activeTab === "legal"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                           
                           onClick={handleShowLegal}
                            type="button"
                        >
                            Pháp lý
                        </button>

                        <button
                          className={`khu-dat-boundary-tab-item ${
                    activeTab === "planning"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                           
                            type="button"
                            onClick={handleShowPlanning}
                        >
                            Quy hoạch
                        </button>

                        <button
                          
                                            className={`khu-dat-boundary-tab-item ${
                    activeTab === "connect"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            type="button"
                            onClick={handleShowConnect}
                        >
                            Hạ tầng &amp; Kết nối
                        </button>

                        <button
                           
                                            className={`khu-dat-boundary-tab-item ${
                    activeTab === "businesses"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            type="button"
                            onClick={handleShowBusinesses}
                            
                        >
                            Doanh nghiệp thuê đất
                        </button>

                        <button
                             className={`khu-dat-boundary-tab-item ${
                    activeTab === "history"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            type="button"
                            onClick={handleShowHistory}
                        >
                            Lịch sử biến động
                        </button>
                    </div>

                    {/* Body */}
                    <div className="khu-dat-boundary-body-wrapper">
                        {/* LEFT */}
                        <div className="khu-dat-boundary-left-panel">
                            <div className="khu-dat-boundary-info-card">
                                <h3 className="khu-dat-boundary-info-title">
                                    Thông tin khu đất
                                </h3>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Tên khu đất
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        Lô CN-01
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Mã khu đất
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        AG-KCNBH-CN01
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Khu công nghiệp
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        KCN Bình Hòa
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Loại đất
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        Đất công nghiệp
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Diện tích
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        50,00 ha
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Diện tích đã cho thuê
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        42,50 ha (85,00%)
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Diện tích còn trống
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        7,50 ha (15,00%)
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-info-row">
                                    <span className="khu-dat-boundary-info-label">
                                        Hiện trạng pháp lý
                                    </span>

                                    <span className="khu-dat-boundary-info-value">
                                        Đã có GCNQSDĐ
                                    </span>
                                </div>
                            </div>

                            {/* TABLE */}
                            <div className="khu-dat-boundary-coordinate-card">
                                <h3 className="khu-dat-boundary-coordinate-title">
                                    Thông số ranh giới
                                </h3>

                                <table className="khu-dat-boundary-table">
                                    <thead>
                                        <tr>
                                            <th>Điểm</th>
                                            <th>Tọa độ X (m)</th>
                                            <th>Tọa độ Y (m)</th>
                                            <th>Chiều dài cạnh (m)</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>1.056.789,12</td>
                                            <td>105.456.789,45</td>
                                            <td>720,50</td>
                                        </tr>

                                        <tr>
                                            <td>2</td>
                                            <td>1.057.468,90</td>
                                            <td>105.457.123,88</td>
                                            <td>540,20</td>
                                        </tr>

                                        <tr>
                                            <td>3</td>
                                            <td>1.057.020,35</td>
                                            <td>105.457.678,90</td>
                                            <td>805,30</td>
                                        </tr>

                                        <tr>
                                            <td>4</td>
                                            <td>1.056.312,45</td>
                                            <td>105.457.245,10</td>
                                            <td>640,80</td>
                                        </tr>

                                        <tr>
                                            <td>5</td>
                                            <td>1.056.789,12</td>
                                            <td>105.456.789,45</td>
                                            <td>560,40</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="khu-dat-boundary-total-wrapper">
                                    <span className="khu-dat-boundary-total-label">
                                        
                                        Tổng chu vi
                                    </span>

                                    <span className="khu-dat-boundary-total-value">
                                        3.267,20 m
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-note-wrapper">
                                    <p className="khu-dat-boundary-note-text">
                                        <i className="fa-solid fa-circle-exclamation icon-kinh-tuyen"></i>
                                        Tọa độ VN-2000, kinh tuyến trục 105°45',
                                        múi chiếu 3°
                                    </p>

                                    <p className="khu-dat-boundary-note-text">
                                        Diện tích tính toán theo tọa độ: 50,00 ha
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="khu-dat-boundary-right-panel">
                            <div className="khu-dat-boundary-map-header">
                                <h3 className="khu-dat-boundary-map-title">
                                    Bản đồ ranh giới
                                </h3>

                                <div className="khu-dat-boundary-map-toolbar">
                                    <select
                                        className="khu-dat-boundary-map-button"
                                        
                                    >
                                        <option>Nền bản đồ: Ảnh vệ tinh</option>
                                    </select>

                                    <select
                                        className="khu-dat-boundary-map-button"
                                        
                                    >
                                        <option>Lớp hiển thị</option>
                                    </select>

                                    <button
                                        className="khu-dat-boundary-map-button"
                                        type="button"
                                    >
                                        ⛶
                                    </button>
                                </div>
                            </div>

                            <div className="khu-dat-boundary-map-wrapper">
                                <img
                                    className="khu-dat-boundary-map-image"
                                    src={ranhgioi}
                                    alt="map"
                                />

                                <div className="khu-dat-boundary-map-overlay">
                                    <div className="khu-dat-boundary-map-polygon"></div>

                                    {/* <div className="khu-dat-boundary-map-center-text">
                                        <span className="khu-dat-boundary-map-center-name">
                                            Lô CN-01
                                        </span>

                                        <span className="khu-dat-boundary-map-center-area">
                                            50,00 ha
                                        </span>
                                    </div> */}

                                    <button
                                        className="khu-dat-boundary-map-zoom-in"
                                        type="button"
                                    >
                                        +
                                    </button>

                                    <button
                                        className="khu-dat-boundary-map-zoom-out"
                                        type="button"
                                    >
                                        −
                                    </button>

                                    <button
                                        className="khu-dat-boundary-map-layer"
                                        type="button"
                                    >
                                        ◉
                                    </button>

                                    <button
                                        className="khu-dat-boundary-map-location"
                                        type="button"
                                    >
                                        ◎
                                    </button>
                                </div>
                            </div>

                            <div className="khu-dat-boundary-legend-wrapper">
                                <div className="khu-dat-boundary-legend-item">
                                    <span className="khu-dat-boundary-legend-line"></span>

                                    <span className="khu-dat-boundary-legend-text">
                                        Ranh giới khu đất
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-legend-item">
                                    <span className="khu-dat-boundary-legend-dash"></span>

                                    <span className="khu-dat-boundary-legend-text">
                                        Thửa đất lân cận
                                    </span>
                                </div>

                                <div className="khu-dat-boundary-legend-item">
                                    <span className="khu-dat-boundary-legend-fill"></span>

                                    <span className="khu-dat-boundary-legend-text">
                                        Quy hoạch KCN
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FOOTER */}
                    <div className="khu-dat-boundary-warning-wrapper">
                        <div className="khu-dat-boundary-warning-title">
                            ⚠ Lưu ý
                        </div>

                        <ul className="khu-dat-boundary-warning-list">
                            <li className="khu-dat-boundary-warning-item">
                                Ranh giới khu đất được xác định theo bản đồ địa
                                chính và GCNQSDĐ số CS 123456 ngày 10/10/2023.
                            </li>

                            <li className="khu-dat-boundary-warning-item">
                                Việc đo đạc thực địa có thể sai số trong giới hạn
                                cho phép theo quy định.
                            </li>
                        </ul>
{/* 
                        <button
                            className="khu-dat-boundary-cancel-button"
                            type="button"
                            onClick={khuDatDetailCloseBoundaryPage}
                        >
                            Hủy
                        </button> */}
                    </div>
                </div>
            </div>
        {/* Ranh giới & bản đồ */}










        {/* Pháp ly */}
            <div
            className={
                    khuDatDetailCurrentPage === "legal"
                        ? "khu-dat-boundary-overlay-show-legal"
                        : "khu-dat-boundary-overlay-hide-legal"
                }
            >
<div className="land-detail-page ">
    <div className="land-detail-header">
        <div className="land-detail-header-left">
            <div className="land-detail-breadcrumb">
                <span className="land-detail-breadcrumb-item">Trang chủ</span>
                <span className="land-detail-breadcrumb-dot">›</span>

                <span className="land-detail-breadcrumb-item">Đất đai</span>
                <span className="land-detail-breadcrumb-dot">›</span>

                <span className="land-detail-breadcrumb-item">Quản lý đất đai</span>
                <span className="land-detail-breadcrumb-dot">›</span>

                <span className="land-detail-breadcrumb-active">Chi tiết khu đất</span>
            </div>

            <h1 className="land-detail-title">
                Chi tiết khu đất: Lô CN-01
            </h1>
        </div>

        <div className="land-detail-header-right">
            <button className="land-detail-edit-btn">
                <i className="fa fa-pencil icon-shareeeee"></i>
                Chỉnh sửa
            </button>

            <button className="land-detail-pdf-btn">
                <i className="fa fa-file-pdf-o"></i>
                Xuất PDF
            </button>

            <button className="land-detail-more-btn">
                Khác
                <i className="fa fa-caret-down icon-downnnn"></i>
            </button>
        </div>
    </div>

    <div className="land-detail-back-wrapper">
        <button className="land-detail-back-btn" onClick={khuDatDetailGoBackPage}>
          <i className="fa-solid fa-arrow-left icon-shareeeee"></i>
            Quay lại
        </button>
    </div>

    <div className="land-detail-tab-wrapper">
        <div className="land-detail-tab-item" onClick={handleOpenDetail}>
            Thông tin chi tiết
        </div>
   {/* className="land-detail-tab-item"  */}
        <div 
         className={`land-detail-back-btn ${
                    activeTab === "boundary"
                        ? "land-detail-tab-active"
                        : ""
                }`}
     onClick={handleOpenMapPage}>
            Ranh giới & Bản đồ
        </div>

        <div 
         className={`land-detail-tab-item  ${
                    activeTab === "legal"
                        ? "land-detail-tab-active"
                        : ""
                }`}
         onClick={handleShowLegal}>
            Pháp lý
        </div>

        <div 
        className={`land-detail-tab-item  ${
                    activeTab === "planning"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        
        onClick={handleShowPlanning}>
            Quy hoạch
        </div>

        <div 
        
         className={`land-detail-tab-item  ${
                    activeTab === "connect"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        
        
        onClick={handleShowConnect}
        
        >
            Hạ tầng & Kết nối
        </div>

        <div 
         
         className={`land-detail-tab-item  ${
                    activeTab === "businesses"
                        ? "land-detail-tab-active"
                        : ""
                }`}
          onClick={handleShowBusinesses}
        >
            Doanh nghiệp thuê đất
        </div>

        <div 
         className={`land-detail-tab-item  ${
                    activeTab === "history"
                        ? "land-detail-tab-active"
                        : ""
                }`}
          onClick={handleShowHistory}
        >
            Lịch sử biến động
        </div>
    </div>

    <div className="land-detail-content-wrapper">

        {/* <!-- TOP --> */}
        <div className="land-detail-top-grid">

            {/* <!-- THÔNG TIN KHU ĐẤT --> */}
            <div className="land-detail-info-card">
                <div className="land-detail-card-title">
                    Thông tin khu đất
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Tên khu đất
                    </div>

                    <div className="land-detail-info-value">
                        : Lô CN-01
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Mã khu đất
                    </div>

                    <div className="land-detail-info-value">
                        : AG-KCNBH-CN01
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Khu công nghiệp
                    </div>

                    <div className="land-detail-info-value">
                        : KCN Bình Hòa
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Loại đất
                    </div>

                    <div className="land-detail-info-value">
                        : Đất công nghiệp
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Diện tích
                    </div>

                    <div className="land-detail-info-value">
                        : 50,00 ha
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Diện tích đã cho thuê
                    </div>

                    <div className="land-detail-info-value">
                        : 42,50 ha (85,00%)
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Diện tích còn trống
                    </div>

                    <div className="land-detail-info-value">
                        : 7,50 ha (15,00%)
                    </div>
                </div>

                <div className="land-detail-info-row">
                    <div className="land-detail-info-label">
                        Hiện trạng pháp lý
                    </div>

                    <div className="land-detail-info-value land-detail-status-green">
                        : Đã có GCNQSDĐ
                    </div>
                </div>
            </div>

            {/* <!-- TÌNH TRẠNG PHÁP LÝ --> */}
            <div className="land-detail-legal-status-card">
                <div className="land-detail-card-title">
                    Tình trạng pháp lý
                </div>

                <div className="land-detail-legal-top-info">

                    <div className="land-detail-legal-top-item">
                        <div className="land-detail-legal-top-label">
                            Tình trạng
                        </div>

                        <div className="land-detail-legal-badge">
                            Đã có Giấy chứng nhận QSDĐ
                        </div>
                    </div>

                    <div className="land-detail-legal-top-item">
                        <div className="land-detail-legal-top-label">
                            Số hiệu GCN
                        </div>

                        <div className="land-detail-legal-top-value">
                            CS 123456
                        </div>
                    </div>

                    <div className="land-detail-legal-top-item">
                        <div className="land-detail-legal-top-label">
                            Ngày cấp
                        </div>

                        <div className="land-detail-legal-top-value">
                            10/01/2023
                        </div>
                    </div>

                    <div className="land-detail-legal-top-item">
                        <div className="land-detail-legal-top-label">
                            Cơ quan cấp
                        </div>

                        <div className="land-detail-legal-top-value">
                            Sở TNMT tỉnh An Giang
                        </div>
                    </div>

                </div>

                <div className="land-detail-process-wrapper">

                    <div className="land-detail-process-line"></div>

                    <div className="land-detail-process-item">
                        <div className="land-detail-process-circle land-detail-process-done">
                            ✓
                        </div>

                        <div className="land-detail-process-title">
                            1. Quyết định giao đất
                        </div>

                        <div className="land-detail-process-date">
                            15/07/2020
                        </div>
                    </div>

                    <div className="land-detail-process-item">
                        <div className="land-detail-process-circle land-detail-process-done">
                            ✓
                        </div>

                        <div className="land-detail-process-title">
                            2. Ký hợp đồng thuê đất
                        </div>

                        <div className="land-detail-process-date">
                            20/07/2020
                        </div>
                    </div>

                    <div className="land-detail-process-item">
                        <div className="land-detail-process-circle land-detail-process-active">
                            ⬤
                        </div>

                        <div className="land-detail-process-title">
                            3. Cấp GCN QSDĐ
                        </div>

                        <div className="land-detail-process-date">
                            10/01/2023
                        </div>
                    </div>

                    <div className="land-detail-process-item">
                        <div className="land-detail-process-circle">
                            ○
                        </div>

                        <div className="land-detail-process-title">
                            4. Hoàn thành nghĩa vụ tài chính
                        </div>

                        <div className="land-detail-process-date">
                            --/--/----
                        </div>
                    </div>

                    <div className="land-detail-process-item">
                        <div className="land-detail-process-circle">
                            ○
                        </div>

                        <div className="land-detail-process-title">
                            5. Cập nhật biến động
                        </div>

                        <div className="land-detail-process-date">
                            --/--/----
                        </div>
                    </div>

                </div>
            </div>
        </div>

        {/* <!-- MIDDLE --> */}
        <div className="land-detail-middle-grid">

            {/* <!-- GIẤY TỜ PHÁP LÝ --> */}
            <div className="land-detail-document-card">

                <div className="land-detail-card-title">
                    Giấy tờ pháp lý
                </div>

                <div className="land-detail-table-wrapper">
                    <table className="land-detail-table">
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>Tên giấy tờ</th>
                                <th>Số/Ký hiệu</th>
                                <th>Ngày cấp</th>
                                <th>Cơ quan cấp</th>
                                <th>File đính kèm</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Quyết định giao đất</td>
                                <td>1234/QĐ-UBND</td>
                                <td>15/07/2020</td>
                                <td>UBND tỉnh An Giang</td>
                                <td>📄</td>
                            </tr>

                            <tr>
                                <td>2</td>
                                <td>Hợp đồng thuê đất</td>
                                <td>HĐTĐ-AG-2020-001</td>
                                <td>28/07/2020</td>
                                <td>Ban QL KKT An Giang</td>
                                <td>📄</td>
                            </tr>

                            <tr>
                                <td>3</td>
                                <td>Giấy chứng nhận QSDĐ</td>
                                <td>CS 123456</td>
                                <td>10/01/2023</td>
                                <td>Sở TNMT An Giang</td>
                                <td>📄</td>
                            </tr>

                            <tr>
                                <td>4</td>
                                <td>Xác nhận hoàn thành nghĩa vụ tài chính</td>
                                <td>789/XN-STNMT</td>
                                <td>05/01/2023</td>
                                <td>Sở TNMT An Giang</td>
                                <td>📄</td>
                            </tr>

                            <tr>
                                <td>5</td>
                                <td>Biên bản bàn giao đất trên thực địa</td>
                                <td>BBBG-AGG-2020-001</td>
                                <td>20/07/2020</td>
                                <td>Ban QL KKT An Giang</td>
                                <td>📄</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="land-detail-view-all">
                    Xem tất cả →
                </div>
            </div>

            {/* <!-- NGHĨA VỤ TÀI CHÍNH --> */}
            <div className="land-detail-finance-card">

                <div className="land-detail-card-title">
                    Thông tin nghĩa vụ tài chính
                </div>

                <div className="land-detail-finance-row">
                    <div className="land-detail-finance-label">
                        Tiền thuê đất
                    </div>

                    <div className="land-detail-finance-value">
                        Trả tiền thuê đất hàng năm
                    </div>
                </div>

                <div className="land-detail-finance-row">
                    <div className="land-detail-finance-label">
                        Đơn giá thuê đất
                    </div>

                    <div className="land-detail-finance-value">
                        120.000 đồng/m²/năm
                    </div>
                </div>

                <div className="land-detail-finance-row">
                    <div className="land-detail-finance-label">
                        Thời hạn thuê
                    </div>

                    <div className="land-detail-finance-value">
                        50 năm (15/07/2020 - 14/07/2070)
                    </div>
                </div>

                <div className="land-detail-finance-row">
                    <div className="land-detail-finance-label">
                        Ngày bắt đầu tính tiền thuê
                    </div>

                    <div className="land-detail-finance-value">
                        15/07/2020
                    </div>
                </div>

                <div className="land-detail-finance-row">
                    <div className="land-detail-finance-label">
                        Tình trạng nộp tiền thuê đất
                    </div>

                    <div className="land-detail-finance-value land-detail-status-green">
                        Đã hoàn thành đến 14/07/2026
                    </div>
                </div>

                <div className="land-detail-finance-row">
                    <div className="land-detail-finance-label">
                        Các khoản phí, lệ phí khác
                    </div>

                    <div className="land-detail-finance-value land-detail-status-green">
                        Đã hoàn thành
                    </div>
                </div>

                <div className="land-detail-finance-link">
                    Xem chi tiết nghĩa vụ tài chính →
                </div>

            </div>
        </div>

        {/* <!-- BOTTOM --> */}
        <div className="land-detail-history-card">

            <div className="land-detail-card-title">
                Lịch sử pháp lý
            </div>

            <div className="land-detail-table-wrapper">

                <table className="land-detail-table">

                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Nội dung</th>
                            <th>Số/Ký hiệu</th>
                            <th>Ngày ban hành</th>
                            <th>Cơ quan ban hành</th>
                            <th>Ghi chú</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td>1</td>
                            <td>Quyết định giao đất</td>
                            <td>1234/QĐ-UBND</td>
                            <td>15/07/2020</td>
                            <td>UBND tỉnh An Giang</td>
                            <td>Giao đất không thu tiền sử dụng đất</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>Hợp đồng thuê đất</td>
                            <td>HĐTĐ-AG-2020-001</td>
                            <td>28/07/2020</td>
                            <td>Ban QL KKT An Giang</td>
                            <td>Thời hạn 50 năm</td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>Giấy chứng nhận QSDĐ</td>
                            <td>CS 123456</td>
                            <td>10/01/2023</td>
                            <td>Sở TNMT An Giang</td>
                            <td>Cấp lần đầu</td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>Xác nhận hoàn thành nghĩa vụ tài chính</td>
                            <td>789/XN-STNMT</td>
                            <td>05/01/2023</td>
                            <td>Sở TNMT An Giang</td>
                            <td>Đã hoàn thành thuế đất năm 2023</td>
                        </tr>

                    </tbody>

                </table>

            </div>

            <div className="land-detail-view-all">
                Xem tất cả →
            </div>

        </div>

    </div>
</div>

            </div>

          {/* Pháp ly */}




























          {/* Quy hoạch */}

            <div
             className={
                    khuDatDetailCurrentPage === "planning"
                        ? "khu-dat-boundary-overlay-show-planning"
                        : "khu-dat-boundary-overlay-hide-planning"
                }
            >
                <div className=" planning-page-container">
    {/* Breadcrumb */}
    <div className="planning-breadcrumb-wrapper">
        <span className="planning-breadcrumb-item">Trang chủ</span>
        <span className="planning-breadcrumb-separator">›</span>

        <span className="planning-breadcrumb-item">Đất đai</span>
        <span className="planning-breadcrumb-separator">›</span>

        <span className="planning-breadcrumb-item">Quản lý đất đai</span>
        <span className="planning-breadcrumb-separator">›</span>

        <span className="planning-breadcrumb-active">
            Chi tiết khu đất
        </span>
    </div>

    {/* Header */}
    <div className="planning-header-wrapper">
        <div className="planning-header-left">
            <h2 className="planning-header-title">
                Chi tiết khu đất: Lô CN-01
            </h2>


            <button className="planning-back-button" onClick={khuDatDetailGoBackPage}>

             <i className="fa-solid fa-arrow-left icon-left-icon"></i> Quay lại
            </button>
        </div>

        <div className="planning-header-right">
            <button className="planning-edit-button">
                ✎ Chỉnh sửa
            </button>

            <button className="planning-pdf-button">
                ⎙ Xuất PDF
            </button>

            <button className="planning-more-button">
                Khác ▼
            </button>
        </div>
    </div>

    {/* Tabs */}
    <div className="planning-tab-wrapper">
        <button 
        className={`planning-tab-item ${
                    activeTab === "detail"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        onClick={handleOpenDetail}>
            Thông tin chi tiết
        </button>

        <button 
           className={`planning-tab-item ${
                    activeTab === "boundary"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        
        onClick={handleOpenMapPage}>
            Ranh giới & Bản đồ
        </button>

        <button
         className={`planning-tab-item ${
                    activeTab === "legal"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        onClick={handleShowLegal}>
            Pháp lý
        </button>


        {/* */}
        <button
        className={`planning-tab-item ${
                    activeTab === "planning"
                        ? "land-detail-tab-active"
                        : ""
                }`}
      onClick={handleShowPlanning}
>
            Quy hoạch
        </button>

        <button 
       className={`planning-tab-item ${
                    activeTab === "connect"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                onClick={handleShowConnect}
                >
            Hạ tầng & Kết nối
        </button>

        <button 
         className={`planning-tab-item ${
                    activeTab === "businesses"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                onClick={handleShowBusinesses}
        >
            Doanh nghiệp thuê đất
        </button>

        <button 
         className={`planning-tab-item ${
                    activeTab === "history"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                onClick={handleShowHistory}
        >
            Lịch sử biến động
        </button>
    </div>

    {/* Main Content */}
    <div className="planning-content-wrapper">
        {/* Left Content */}
        <div className="planning-left-sidebar">
            {/* Planning Information */}
            <div className="planning-info-card">
                <div className="planning-card-title">
                    Thông tin quy hoạch
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Quy hoạch phân khu
                    </span>

                    <span className="planning-info-value">
                        Phân khu KCN Bình Hòa
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Chức năng sử dụng đất
                    </span>

                    <span className="planning-info-value">
                        Đất công nghiệp
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Ký hiệu lô đất quy hoạch
                    </span>

                    <span className="planning-info-value">
                        CN-01
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Diện tích theo quy hoạch
                    </span>

                    <span className="planning-info-value">
                        50,00 ha
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Tỷ lệ bản đồ quy hoạch
                    </span>

                    <span className="planning-info-value">
                        1/2.000
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Cơ quan phê duyệt
                    </span>

                    <span className="planning-info-value">
                        UBND tỉnh An Giang
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Số quyết định
                    </span>

                    <span className="planning-info-value">
                        1234/QĐ-UBND
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Ngày phê duyệt
                    </span>

                    <span className="planning-info-value">
                        15/07/2020
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Tình trạng
                    </span>

                    <span className="planning-status-active">
                        Đang hiệu lực
                    </span>
                </div>

                <div className="planning-info-row">
                    <span className="planning-info-label">
                        Ghi chú
                    </span>

                    <span className="planning-info-value">
                        -
                    </span>
                </div>
            </div>

            {/* Planning Detail */}
            <div className="planning-detail-card">
                <div className="planning-card-title">
                    Chỉ tiêu quy hoạch
                </div>

                <div className="planning-detail-table-header">
                    <span>Chỉ tiêu</span>
                    <span>Theo quy hoạch</span>
                    <span>Đơn vị</span>
                </div>

                <div className="planning-detail-table-row">
                    <span>Mật độ xây dựng tối đa</span>
                    <span>≤ 60</span>
                    <span>%</span>
                </div>

                <div className="planning-detail-table-row">
                    <span>Tầng cao tối đa</span>
                    <span>≤ 4</span>
                    <span>tầng</span>
                </div>

                <div className="planning-detail-table-row">
                    <span>Hệ số sử dụng đất</span>
                    <span>≤ 2.0</span>
                    <span>lần</span>
                </div>

                <div className="planning-detail-table-row">
                    <span>Khoảng lùi xây dựng</span>
                    <span>Theo QH chi tiết</span>
                    <span>m</span>
                </div>

                <div className="planning-detail-table-row">
                    <span>Chiều cao công trình</span>
                    <span>≤ 40</span>
                    <span>m</span>
                </div>
            </div>
        </div>

        {/* Right Content */}
        <div className="planning-map-section">
            {/* Map Header */}
            <div className="planning-map-header">
                <div className="planning-map-title">
                    Bản đồ quy hoạch sử dụng đất
                </div>

                <div className="planning-map-tools">
                    <select className="planning-map-select">
                        <option>
                            Bản đồ quy hoạch sử dụng đất
                        </option>
                    </select>

                    <button className="planning-map-button">
                        <i className="fa-solid fa-expand"></i> Toàn bản đồ
                    </button>

                    <button className="planning-map-button">
                        <i className="fa-solid fa-maximize"></i>
                    </button>
                </div>
            </div>

            {/* Map Image */}
            <div className="planning-map-image-wrapper">
                <div className='loca-warper'>
                    <i className="fa-solid fa-crosshairs icon-loca-crosshairs"></i>
                </div>
                <img
                    src={quyhoach}
                    alt="planning-map"
                    className="planning-map-image"
                />

                {/* Map Controls */}
                <div className="planning-map-control-group">
                    <button className="planning-map-control-button">
                        +
                    </button>

                    <button className="planning-map-control-button">
                        −
                    </button>

                    <button className="planning-map-control-button">
                        ◈
                    </button>
                </div>
            </div>

            {/* Legend */}
            <div className="planning-map-legend-wrapper">
                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-industrial"></span>
                    <span className="planning-legend-text">
                        Đất công nghiệp
                    </span>
                </div>

                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-commercial"></span>
                    <span className="planning-legend-text">
                        Đất dịch vụ - thương mại
                    </span>
                </div>

                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-green"></span>
                    <span className="planning-legend-text">
                        Đất cây xanh
                    </span>
                </div>

                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-technical"></span>
                    <span className="planning-legend-text">
                        Đất hạ tầng kỹ thuật
                    </span>
                </div>

                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-traffic"></span>
                    <span className="planning-legend-text">
                        Đất giao thông
                    </span>
                </div>

                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-water"></span>
                    <span className="planning-legend-text">
                        Mặt nước
                    </span>
                </div>

                <div className="planning-legend-item">
                    <span className="planning-legend-color planning-legend-other"></span>
                    <span className="planning-legend-text">
                        Đất khác
                    </span>
                </div>
            </div>

            {/* Legal Documents */}
            <div className="planning-document-card">
                <div className="planning-card-title">
                    Văn bản pháp lý quy hoạch liên quan
                </div>

                <table className="planning-document-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Tên văn bản</th>
                            <th>Số/Ký hiệu</th>
                            <th>Ngày ban hành</th>
                            <th>Cơ quan ban hành</th>
                            <th>Trích yếu</th>
                            <th>File đính kèm</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>
                                Quyết định phê duyệt đồ án quy hoạch phân khu KCN Bình Hòa
                            </td>
                            <td>1234/QĐ-UBND</td>
                            <td>15/07/2020</td>
                            <td>UBND tỉnh An Giang</td>
                            <td>
                                Phê duyệt đồ án quy hoạch phân khu KCN Bình Hòa, tỷ lệ 1/2.000
                            </td>
                            <td><i className="fa-regular fa-file-pdf icon-pdf-file-fa"></i></td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>
                                Quyết định điều chỉnh cục bộ quy hoạch phân khu KCN Bình Hòa
                            </td>
                            <td>2567/QĐ-UBND</td>
                            <td>29/06/2022</td>
                            <td>UBND tỉnh An Giang</td>
                            <td>
                                Điều chỉnh cục bộ một số chỉ tiêu và ranh giới quy hoạch
                            </td>
                            <td>
                                <i className="fa-regular fa-file-pdf icon-pdf-file-fa"></i>
                            </td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>
                                Quy định quản lý theo đồ án quy hoạch phân khu
                            </td>
                            <td>789/QĐ-UBND</td>
                            <td>10/08/2020</td>
                            <td>UBND tỉnh An Giang</td>
                            <td>
                                Ban hành quy định quản lý theo đồ án quy hoạch phân khu
                            </td>
                            <td>
                                <i className="fa-regular fa-file-pdf icon-pdf-file-fa"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <button className="planning-view-document-button">
                    Xem tất cả văn bản →
                </button>
            </div>
        </div>
    </div>
</div>


            </div>





          {/* Quy hoạch */}














          {/* Hạ tầng kết nối */}

                <div
                 className={
                    khuDatDetailCurrentPage === "connect"
                        ? "khu-dat-boundary-overlay-show-connect"
                        : "khu-dat-boundary-overlay-hide-connect"
                }
                >
 <div className="connect-content-column">

        {/* ========================= HEADER BREADCRUMB ========================= */}
        <div className="connect-detail-breadcrumb">
            <span className="connect-detail-breadcrumb-text">
                Trang chủ
            </span>

            <span className="connect-detail-breadcrumb-arrow">
                &gt;
            </span>

            <span className="connect-detail-breadcrumb-text">
                Đất đai
            </span>

            <span className="connect-detail-breadcrumb-arrow">
                &gt;
            </span>

            <span className="connect-detail-breadcrumb-text">
                Quản lý đất đai
            </span>

            <span className="connect-detail-breadcrumb-arrow">
                &gt;
            </span>

            <span className="connect-detail-breadcrumb-active">
                Chi tiết khu đất
            </span>
        </div>

        {/* ========================= TITLE + ACTION ========================= */}
        <div className="connect-detail-topbar">

            <div className="connect-detail-topbar-left">
                <h2 className="connect-detail-title">
                    Chi tiết khu đất: Lô CN-01
                </h2>

                <button className="connect-detail-back-button" onClick={khuDatDetailGoBackPage}>
                    ← Quay lại
                </button>
            </div>

            <div className="connect-detail-topbar-right">

                <button className="connect-detail-action-button">
                    ✎ Chỉnh sửa
                </button>

                <button className="connect-detail-action-button">
                    ⬇ Xuất PDF
                </button>

                <button className="connect-detail-more-button">
                    Khác ▼
                </button>

            </div>
        </div>

        {/* ========================= TAB ========================= */}
        <div className="connect-detail-tab-wrapper">

            <div 
               className={`connect-detail-tab-item ${
                    activeTab === "detail"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        onClick={handleOpenDetail}>
           
                Thông tin chi tiết
            </div>

            <div 
          
              className={`connect-detail-tab-item ${
                    activeTab === "boundary"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                onClick={handleOpenMapPage}
            >
                Ranh giới & Bản đồ
            </div>

            <div
             className={`connect-detail-tab-item ${
                    activeTab === "legal"
                        ? "land-detail-tab-active"
                        : ""
                }`}

                onClick={handleShowLegal}
            >
                Pháp lý
            </div>

            <div 
            className={`connect-detail-tab-item ${
                    activeTab === "planning"
                        ? "land-detail-tab-active"
                        : ""
                }`}
            onClick={handleShowPlanning}
            >
                Quy hoạch
            </div>

            <div 
            className={`connect-detail-tab-item ${
                    activeTab === "connect"
                        ? "land-detail-tab-active"
                        : ""
                }`} 
                onClick={handleShowConnect}
                >
                Hạ tầng & Kết nối
            </div>

            <div 
             className={`connect-detail-tab-item ${
                    activeTab === "businesses"
                        ? "land-detail-tab-active"
                        : ""
                }`} 
                onClick={handleShowBusinesses}
            >
                Doanh nghiệp thuê đất
            </div>

            <div 
             className={`connect-detail-tab-item ${
                    activeTab === "history"
                        ? "land-detail-tab-active"
                        : ""
                }`} 
                onClick={handleShowHistory}
            >
                Lịch sử biến động
            </div>

        </div>

        {/* ========================= CONTENT ========================= */}
        <div className="connect-detail-main-content">

            {/* ========================= LEFT INFO ========================= */}
            <div className="connect-detail-left-panel">

                {/* ========================= INFO CARD ========================= */}
                <div className="connect-detail-card">

                    <div className="connect-detail-card-title">
                        Thông tin khu đất
                    </div>

                    <div className="connect-detail-info-row">
                        <span className="connect-detail-info-label">
                            Tên khu đất
                        </span>

                        <span className="connect-detail-info-value">
                            Lô CN-01
                        </span>
                    </div>

                    <div className="connect-detail-info-row">
                        <span className="connect-detail-info-label">
                            Mã khu đất
                        </span>

                        <span className="connect-detail-info-value">
                            AG-KCNBH-CN01
                        </span>
                    </div>

                    <div className="connect-detail-info-row">
                        <span className="connect-detail-info-label">
                            Khu công nghiệp
                        </span>

                        <span className="connect-detail-info-value">
                            KCN Bình Hòa
                        </span>
                    </div>

                    <div className="connect-detail-info-row">
                        <span className="connect-detail-info-label">
                            Loại đất
                        </span>

                        <span className="connect-detail-info-value">
                            Đất công nghiệp
                        </span>
                    </div>

                    <div className="connect-detail-info-row">
                        <span className="connect-detail-info-label">
                            Diện tích
                        </span>

                        <span className="connect-detail-info-value">
                            50,00 ha
                        </span>
                    </div>

                    <div className="connect-detail-info-row">
                        <span className="connect-detail-info-label">
                            Địa chỉ
                        </span>

                        <span className="connect-detail-info-value">
                            KCN Bình Hòa, huyện Châu Thành,
                            tỉnh An Giang
                        </span>
                    </div>

                </div>

                {/* ========================= DISTANCE CARD ========================= */}
                <div className="connect-detail-card">

                    <div className="connect-detail-card-title">
                        Khoảng cách kết nối
                    </div>

                    <div className="connect-detail-distance-row">
                        <span className="connect-detail-distance-name">
                            Trung tâm TP. Long Xuyên
                        </span>

                        <span className="connect-detail-distance-value">
                            12 km
                        </span>
                    </div>

                    <div className="connect-detail-distance-row">
                        <span className="connect-detail-distance-name">
                            Cảng Quốc tế Long Xuyên
                        </span>

                        <span className="connect-detail-distance-value">
                            12 km
                        </span>
                    </div>

                    <div className="connect-detail-distance-row">
                        <span className="connect-detail-distance-name">
                            Sân bay Cần Thơ
                        </span>

                        <span className="connect-detail-distance-value">
                            85 km
                        </span>
                    </div>

                    <div className="connect-detail-distance-row">
                        <span className="connect-detail-distance-name">
                            Cửa khẩu Vĩnh Xương
                        </span>

                        <span className="connect-detail-distance-value">
                            35 km
                        </span>
                    </div>

                    <div className="connect-detail-distance-row">
                        <span className="connect-detail-distance-name">
                            Quốc lộ 91
                        </span>

                        <span className="connect-detail-distance-value">
                            1,2 km
                        </span>
                    </div>

                    <div className="connect-detail-distance-row">
                        <span className="connect-detail-distance-name">
                            Đường N1 (22m)
                        </span>

                        <span className="connect-detail-distance-value">
                            0,2 km
                        </span>
                    </div>

                </div>

            </div>

            {/* ========================= RIGHT MAP ========================= */}
            <div className="connect-detail-right-panel">

                <div className="connect-detail-map-title">
                    Sơ đồ hạ tầng kết nối
                </div>

                <div className="connect-detail-map-wrapper">

                    <img
                        className="connect-detail-map-image"
                        src={ketnoi}
                        alt="map"
                    />

                    {/* ========================= MAP CENTER BOX ========================= */}
                    {/* <div className="connect-detail-map-center-box">
                        <div className="connect-detail-map-center-title">
                            CN-01
                        </div>

                        <div className="connect-detail-map-center-area">
                            50,00 ha
                        </div>
                    </div> */}

                    {/* ========================= MAP ZOOM ========================= */}
                    <div className="connect-detail-map-zoom">

                        <button className="connect-detail-map-zoom-button">
                            +
                        </button>

                        <button className="connect-detail-map-zoom-button">
                            −
                        </button>

                    </div>

                </div>

                {/* ========================= LEGEND ========================= */}
                <div className="connect-detail-map-legend">

                    <div className="connect-detail-map-legend-item">
                        <div className="connect-detail-map-legend-line connect-detail-map-road"></div>
                        Đường bộ
                    </div>

                    <div className="connect-detail-map-legend-item">
                        <div className="connect-detail-map-legend-line connect-detail-map-highway"></div>
                        Quốc lộ
                    </div>

                    <div className="connect-detail-map-legend-item">
                        <div className="connect-detail-map-legend-line connect-detail-map-existing"></div>
                        Đường hiện hữu
                    </div>

                    <div className="connect-detail-map-legend-item">
                        <div className="connect-detail-map-legend-line connect-detail-map-railway"></div>
                        Đường sắt
                    </div>

                    <div className="connect-detail-map-legend-item">
                        <div className="connect-detail-map-legend-line connect-detail-map-water"></div>
                        Đường thủy
                    </div>

                </div>

            </div>

        </div>

        {/* ========================= BOTTOM GRID ========================= */}
        <div className="connect-detail-bottom-grid">

            {/* ========================= TRANSPORT ========================= */}
            <div className="connect-detail-bottom-card">

                <div className="connect-detail-bottom-title">
                    Hệ thống giao thông
                </div>

                <table className="connect-detail-table">
                    <thead>
                        <tr>
                            <th>Tuyến đường</th>
                            <th>Loại đường</th>
                            <th>Quy mô</th>
                            <th>Khoảng cách</th>
                            <th>Tình trạng</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td>Quốc lộ 91</td>
                            <td>Quốc lộ</td>
                            <td>4 làn xe</td>
                            <td>1,2 km</td>
                             <td >
                                <span className='active-exploit'>Đang khai thác</span>
                            </td>
                        </tr>

                        <tr>
                            <td>Đường N1</td>
                            <td>Đường chính KCN</td>
                            <td>22 m (4 làn xe)</td>
                            <td>0,2 km</td>
                             <td >
                                <span className='active-exploit'>Đang khai thác</span>
                            </td>
                        </tr>

                        <tr>
                            <td>Đường N2</td>
                            <td>Đường chính KCN</td>
                            <td>22 m (4 làn xe)</td>
                            <td>0,4 km</td>
                            <td >
                                <span className='active-exploit'>Đang khai thác</span>
                            </td>
                        </tr>

                        <tr>
                            <td>Đường D1</td>
                            <td>Đường nhánh KCN</td>
                            <td>15 m (2 làn xe)</td>
                            <td>0,1 km</td>
                            <td >
                                <span className='active-exploit'>Đang khai thác</span>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <button className="connect-detail-view-button">
                    Xem chi tiết giao thông →
                </button>

            </div>

            {/* ========================= TECHNICAL ========================= */}
            <div className="connect-detail-bottom-card">

                <div className="connect-detail-bottom-title">
                    Hệ thống cấp kỹ thuật
                </div>

                <table className="connect-detail-table">
                    <thead>
                        <tr>
                            <th>Hệ thống</th>
                            <th>Nguồn cấp</th>
                            <th>Năng suất</th>
                            <th>Khoảng cách</th>
                            <th>Tình trạng</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td>Điện</td>
                            <td>Trạm 110kV Bình Hòa</td>
                            <td>2x63 MVA</td>
                            <td>0,5 km</td>
                            <td >
                                <span className='active-exploit'>Đáp ứng</span>
                            </td>
                        </tr>

                        <tr>
                            <td>Nước sạch</td>
                            <td>Nhà máy nước Bình Hòa</td>
                            <td>10.000 m³/ngày</td>
                            <td>0,6 km</td>
                           <td >
                                <span className='active-exploit'>Đáp ứng</span>
                            </td>
                        </tr>

                        <tr>
                            <td>Nước thải</td>
                            <td>Trạm XLNT tập trung</td>
                            <td>8.000 m³/ngày</td>
                            <td>0,4 km</td>
                            <td >
                                <span className='active-exploit'>Đáp ứng</span>
                            </td>
                        </tr>

                        <tr>
                            <td>Thông tin liên lạc</td>
                            <td>VNPT, Viettel, FPT</td>
                            <td>Đầy đủ</td>
                            <td>0,2 km</td>
                         <td >
                                <span className='active-exploit'>Đáp ứng</span>
                            </td>
                        </tr>

                        <tr>
                            <td>PCCC</td>
                            <td>Trạm PCCC KCN Bình Hòa</td>
                            <td>-</td>
                            <td>0,4 km</td>
                           <td >
                                <span className='active-exploit'>Đáp ứng</span>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <button className="connect-detail-view-button">
                    Xem chi tiết hạ tầng kỹ thuật →
                </button>

            </div>

            {/* ========================= NOTE ========================= */}
            <div className="connect-detail-note-card">

                <div className="connect-detail-bottom-title">
                    Ghi chú
                </div>

                <ul className="connect-detail-note-list">

                    <li className="connect-detail-note-item">
                        Các tuyến đường nội bộ trong KCN đã được đầu tư hoàn thiện.
                    </li>

                    <li className="connect-detail-note-item">
                        Hệ thống hạ tầng kỹ thuật đồng bộ, đáp ứng nhu cầu của nhà đầu tư.
                    </li>

                    <li className="connect-detail-note-item">
                        Khoảng cách tính theo đường bộ.
                    </li>

                </ul>

                <button className="connect-detail-download-button">
                    ⬇ Tải sơ đồ hạ tầng (PDF)
                </button>

            </div>

        </div>

    </div>
                    
                </div>

            {/* Hạ tầng kết nối */}











        








        {/* Doanh nghiệp thuê đất */}
        <div  className={
                    khuDatDetailCurrentPage === "businesses"
                        ? "khu-dat-boundary-overlay-show-businesses"
                        : "khu-dat-boundary-overlay-hide-businesses"
                }>

          <div className="businesses-page-container">

            {/* Breadcrumb */}
            <div className="businesses-breadcrumb-wrapper">
                <span className="businesses-breadcrumb-item">Trang chủ</span>
                <span className="businesses-breadcrumb-dot">›</span>

                <span className="businesses-breadcrumb-item">Đất đai</span>
                <span className="businesses-breadcrumb-dot">›</span>

                <span className="businesses-breadcrumb-item">Quản lý đất đai</span>
                <span className="businesses-breadcrumb-dot">›</span>

                <span className="businesses-breadcrumb-active">
                    Chi tiết khu đất
                </span>
            </div>

            {/* Header */}
            <div className="businesses-header-wrapper">
                <div className="businesses-header-left">
                    <h2 className="businesses-page-title">
                        Chi tiết khu đất: Lô CN-01
                    </h2>

                    <button className="businesses-back-button" onClick={khuDatDetailGoBackPage}>
                        ←   Quay lại
                    </button>
                </div>

                <div className="businesses-header-right">
                    <button className="businesses-edit-button">
                        ✎ Chỉnh sửa
                    </button>

                    <button className="businesses-pdf-button">
                        ⬇ Xuất PDF
                    </button>

                    <button className="businesses-more-button">
                        Khác ▾
                    </button>
                </div>
            </div>

            {/* Tabs */}
            <div className="businesses-tab-wrapper">
                <button 
                 className={`businesses-tab-item ${
                    activeTab === "detail"
                        ? "land-detail-tab-active"
                        : ""
                }`}
        onClick={handleOpenDetail}
                
                >
                    Thông tin chi tiết
                </button>

                <button 
                
                 className={`
               businesses-tab-item ${
                    activeTab === "boundary"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                onClick={handleOpenMapPage}
                >
                    Ranh giới & Bản đồ
                </button>

                <button 
                 className={`businesses-tab-item ${
                    activeTab === "legal"
                        ? "land-detail-tab-active"
                        : ""
                }`}

                onClick={handleShowLegal}
                >
                    Pháp lý
                </button>

                <button 
                 className={`businesses-tab-item ${
                    activeTab === "planning"
                        ? "land-detail-tab-active"
                        : ""
                }`}
            onClick={handleShowPlanning}
                
                >
                    Quy hoạch
                </button>

                <button
                 className={`businesses-tab-item ${
                    activeTab === "connect"
                        ? "land-detail-tab-active"
                        : ""
                }`} 
                onClick={handleShowConnect}
                >
                    Hạ tầng & Kết nối
                </button>

                <button 
                className={`businesses-tab-item ${
                    activeTab === "businesses"
                        ? "land-detail-tab-active"
                        : ""
                }`} 
                onClick={handleShowBusinesses}
                
               >
                    Doanh nghiệp thuê đất
                </button>

                <button 
                 className={`businesses-tab-item ${
                    activeTab === "history"
                        ? "land-detail-tab-active"
                        : ""
                }`} 
                onClick={handleShowHistory}
                >
                    Lịch sử biến động
                </button>
            </div>

            {/* Top cards */}
            <div className="businesses-top-card-grid">

                {/* Thông tin khu đất */}
                <div className="businesses-top-card">
                    <h3 className="businesses-card-title">
                        Thông tin khu đất
                    </h3>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Tên khu đất
                        </span>

                        <span className="businesses-info-value">
                            : Lô CN-01
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Mã khu đất
                        </span>

                        <span className="businesses-info-value">
                            : AG-KCNBH-CN01
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Khu công nghiệp
                        </span>

                        <span className="businesses-info-value">
                            : KCN Bình Hòa
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Loại đất
                        </span>

                        <span className="businesses-info-value">
                            : Đất công nghiệp
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Diện tích
                        </span>

                        <span className="businesses-info-value">
                            : 50,00 ha
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Diện tích đã cho thuê
                        </span>

                        <span className="businesses-info-value">
                            : 42,50 ha (85,00%)
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Diện tích còn trống
                        </span>

                        <span className="businesses-info-value">
                            : 7,50 ha (15,00%)
                        </span>
                    </div>

                    <div className="businesses-info-row">
                        <span className="businesses-info-label">
                            Hiện trạng pháp lý
                        </span>

                        <span className="businesses-info-value">
                            : Đã có GCNQSDĐ
                        </span>
                    </div>
                </div>

                {/* Tổng quan cho thuê */}
                <div className="businesses-top-card">
                    <h3 className="businesses-card-title">
                        Tổng quan cho thuê
                    </h3>

                    <div className="businesses-pie-wrapper">

                        {/* Pie chart */}
                        <div className="businesses-pie-chart">
                            <div className="businesses-pie-center">
                                <h4>50,00 ha</h4>
                                <span>Tổng diện tích</span>
                            </div>
                        </div>

                        {/* Legend */}
                        <div className="businesses-pie-legend">

                            <div className="businesses-legend-item">
                                <span className="businesses-legend-dot businesses-green-dot"></span>

                                <div>
                                    <p>Đã cho thuê</p>
                                    <span>42,50 ha (85,00%)</span>
                                </div>
                            </div>

                            <div className="businesses-legend-item">
                                <span className="businesses-legend-dot businesses-blue-dot"></span>

                                <div>
                                    <p>Đang đàm phán</p>
                                    <span>2,00 ha (4,00%)</span>
                                </div>
                            </div>

                            <div className="businesses-legend-item">
                                <span className="businesses-legend-dot businesses-yellow-dot"></span>

                                <div>
                                    <p>Còn trống</p>
                                    <span>7,50 ha (15,00%)</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Diện tích theo trạng thái */}
                <div className="businesses-top-card">
                    <h3 className="businesses-card-title">
                        Diện tích theo trạng thái
                    </h3>

                    <table className="businesses-status-table">
                        <thead>
                            <tr>
                                <th>Trạng thái</th>
                                <th>Diện tích (ha)</th>
                                <th>Tỷ lệ</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>
                                    <div className="businesses-status-name">
                                        <span className="businesses-green-dot businesses-small-dot"></span>
                                        Đã cho thuê
                                    </div>
                                </td>

                                <td>42,50</td>
                                <td>85,00%</td>
                            </tr>

                            <tr>
                                <td>
                                    <div className="businesses-status-name">
                                        <span className="businesses-blue-dot businesses-small-dot"></span>
                                        Đang đàm phán
                                    </div>
                                </td>

                                <td>2,00</td>
                                <td>4,00%</td>
                            </tr>

                            <tr>
                                <td>
                                    <div className="businesses-status-name">
                                        <span className="businesses-yellow-dot businesses-small-dot"></span>
                                        Còn trống
                                    </div>
                                </td>

                                <td>7,50</td>
                                <td>15,00%</td>
                            </tr>

                            <tr className="businesses-total-row">
                                <td>Tổng</td>
                                <td>50,00</td>
                                <td>100%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            {/* Table */}
            <div className="businesses-company-section">

                <div className="businesses-company-header">
                    <h3 className="businesses-card-title">
                        Danh sách doanh nghiệp thuê đất (6)
                    </h3>

                    <div className="businesses-company-tools">
                        <select className="businesses-filter-select">
                            <option>Tất cả trạng thái</option>
                        </select>

                        <input
                            type="text"
                            className="businesses-search-input"
                            placeholder="Tìm kiếm doanh nghiệp..."
                        />
                        <i className="fa-solid fa-magnifying-glass icon-search-iconn-busn"></i>
                    </div>
                </div>

                <div className="businesses-table-scroll">
                    <table className="businesses-company-table">
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>Tên doanh nghiệp</th>
                                <th>Diện tích thuê (ha)</th>
                                <th>Thời hạn thuê</th>
                                <th>Ngày bắt đầu</th>
                                <th>Ngày hết hạn</th>
                                <th>Tình trạng</th>
                                <th>Hợp đồng</th>
                                <th>Ngành nghề chính</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Công ty TNHH An Giang Garment</td>
                                <td>20,00</td>
                                <td>10 năm</td>
                                <td>15/07/2020</td>
                                <td>14/07/2030</td>

                                <td>
                                    <span className="businesses-status-badge">
                                        Đang thuê
                                    </span>
                                </td>

                                <td>HĐTĐ-AG-2020-001</td>
                                <td>May mặc</td>
                            </tr>

                            <tr>
                                <td>2</td>
                                <td>Công ty CP Cơ khí Chính xác AG</td>
                                <td>12,50</td>
                                <td>15 năm</td>
                                <td>01/03/2019</td>
                                <td>28/02/2034</td>

                                <td>
                                    <span className="businesses-status-badge">
                                        Đang thuê
                                    </span>
                                </td>

                                <td>HĐTĐ-CKX-2019-002</td>
                                <td>Cơ khí chế tạo</td>
                            </tr>

                            <tr>
                                <td>3</td>
                                <td>Công ty TNHH Điện tử AG</td>
                                <td>10,00</td>
                                <td>20 năm</td>
                                <td>10/11/2021</td>
                                <td>09/11/2041</td>

                                <td>
                                    <span className="businesses-status-badge">
                                        Đang thuê
                                    </span>
                                </td>

                                <td>HĐTĐ-DT-2021-003</td>
                                <td>Điện tử</td>
                            </tr>

                            <tr>
                                <td>4</td>
                                <td>Công ty TNHH Bao bì Bình Hòa</td>
                                <td>5,00</td>
                                <td>10 năm</td>
                                <td>20/04/2022</td>
                                <td>19/04/2032</td>

                                <td>
                                    <span className="businesses-status-badge">
                                        Đang thuê
                                    </span>
                                </td>

                                <td>HĐTĐ-BB-2022-004</td>
                                <td>Bao bì</td>
                            </tr>

                            <tr>
                                <td>5</td>
                                <td>Công ty CP Thực phẩm AG</td>
                                <td>3,00</td>
                                <td>15 năm</td>
                                <td>05/01/2023</td>
                                <td>04/01/2038</td>

                                <td>
                                    <span className="businesses-status-badge">
                                        Đang thuê
                                    </span>
                                </td>

                                <td>HĐTĐ-TP-2023-005</td>
                                <td>Thực phẩm</td>
                            </tr>

                            <tr>
                                <td>6</td>
                                <td>Công ty TNHH Logistics Bình Hòa</td>
                                <td>2,00</td>
                                <td>10 năm</td>
                                <td>01/08/2024</td>
                                <td>31/07/2034</td>

                                <td>
                                    <span className="businesses-status-badge businesses-status-blue">
                                        Đang đàm phán
                                    </span>
                                </td>

                                <td>-</td>
                                <td>Kho bãi, logistics</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="businesses-table-footer">
                    <span>
                        Hiển thị 1 - 6 trong tổng số 6 doanh nghiệp
                    </span>

                    <div className="businesses-pagination">
                        <span>10 / trang</span>

                        <button>‹</button>
                        <button className="businesses-page-active">1</button>
                        <button>›</button>
                    </div>
                </div>

            </div>

            {/* Bottom */}
            <div className="businesses-bottom-grid">

                {/* Điều khoản */}
                <div className="businesses-bottom-card">
                    <h3 className="businesses-card-title">
                        Điều khoản thuê đất điển hình
                    </h3>

                    <ul className="businesses-condition-list">
                        <li>
                            <i className="fa-regular fa-circle-check icon-check-fa-regular"></i>
                            Hình thức thuê: Nhà nước cho thuê đất trả tiền hàng năm
                        </li>

                        <li>
                             <i className="fa-regular fa-circle-check icon-check-fa-regular"></i>
                            Đơn giá thuê đất: 120.000 đồng/m²/năm (chưa bao gồm VAT)
                        </li>

                        <li>
                             <i className="fa-regular fa-circle-check icon-check-fa-regular"></i>
                            Phí quản lý hạ tầng: 8.000 đồng/m²/năm
                        </li>

                        <li>
                             <i className="fa-regular fa-circle-check icon-check-fa-regular"></i>
                            Tiền đặt cọc: 03 tháng tiền thuê đất
                        </li>

                        <li>
                             <i className="fa-regular fa-circle-check icon-check-fa-regular"></i>
                            Điều chỉnh đơn giá: 05 năm/lần theo quy định của UBND tỉnh An Giang
                        </li>
                    </ul>
                </div>

                {/* Bar chart */}
                <div className="businesses-bottom-card">
                    <h3 className="businesses-card-title">
                        Biểu đồ diện tích thuê theo năm
                    </h3>

                    <div className="businesses-bar-chart-wrapper">

                        {/* Trục Y */}
                        <div className="businesses-bar-y-axis">
                            <span>50</span>
                            <span>40</span>
                            <span>30</span>
                            <span>20</span>
                            <span>10</span>
                            <span>0</span>
                        </div>

                        {/* Chart */}
                        <div className="businesses-bar-chart">

                            {/* Grid lines */}
                            <div className="businesses-grid-line businesses-grid-1"></div>
                            <div className="businesses-grid-line businesses-grid-2"></div>
                            <div className="businesses-grid-line businesses-grid-3"></div>
                            <div className="businesses-grid-line businesses-grid-4"></div>
                            <div className="businesses-grid-line businesses-grid-5"></div>

                            {/* Bars */}
                            <div className="businesses-bar-item">
                                <span className="businesses-bar-value">
                                    15,00
                                </span>

                                <div
                                    className="businesses-bar-column businesses-bar-2020"
                                ></div>

                                <p>2020</p>
                            </div>

                            <div className="businesses-bar-item">
                                <span className="businesses-bar-value">
                                    25,00
                                </span>

                                <div
                                    className="businesses-bar-column businesses-bar-2021"
                                ></div>

                                <p>2021</p>
                            </div>

                            <div className="businesses-bar-item">
                                <span className="businesses-bar-value">
                                    30,00
                                </span>

                                <div
                                    className="businesses-bar-column businesses-bar-2022"
                                ></div>

                                <p>2022</p>
                            </div>

                            <div className="businesses-bar-item">
                                <span className="businesses-bar-value">
                                    35,00
                                </span>

                                <div
                                    className="businesses-bar-column businesses-bar-2023"
                                ></div>

                                <p>2023</p>
                            </div>

                            <div className="businesses-bar-item">
                                <span className="businesses-bar-value">
                                    37,50
                                </span>

                                <div
                                    className="businesses-bar-column businesses-bar-2024"
                                ></div>

                                <p>2024</p>
                            </div>

                            <div className="businesses-bar-item">
                                <span className="businesses-bar-value">
                                    42,50
                                </span>

                                <div
                                    className="businesses-bar-column businesses-bar-2025"
                                ></div>

                                <p>2025</p>
                            </div>

                        </div>

                        {/* Label */}
                        <div className="businesses-chart-label">
                            Diện tích (ha)
                        </div>
                    </div>

                    <p className="businesses-chart-note">
                        (Số liệu tính đến ngày 12/05/2025)
                    </p>
                </div>

            </div>

        </div>

        </div>

        {/* Doanh nghiệp thuê đất */}


















        {/* Lịch sử biến đông */}

      <div   className={
                    khuDatDetailCurrentPage === "history"
                        ? "khu-dat-boundary-overlay-show-history"
                        : "khu-dat-boundary-overlay-hide-history"
                }>

        <div className=" history-page-wrapper">
    {/* Breadcrumb */}
    <div className="history-breadcrumb">
        <span className="history-breadcrumb-item">Trang chủ</span>
        <span className="history-breadcrumb-dot">›</span>

        <span className="history-breadcrumb-item">Đất đai</span>
        <span className="history-breadcrumb-dot">›</span>

        <span className="history-breadcrumb-item">Quản lý đất đai</span>
        <span className="history-breadcrumb-dot">›</span>

        <span className="history-breadcrumb-active">Chi tiết khu đất</span>
    </div>

    {/* Header */}
    <div className="history-header-wrapper">
        <div className="history-header-left">
            <h2 className="history-page-title">
                Chi tiết khu đất: Lô CN-01
            </h2>

            <button className="history-back-button" onClick={khuDatDetailGoBackPage}>
                ← Quay lại
            </button>
        </div>

        <div className="history-header-right">
            <button className="history-edit-button">
                ✎ Chỉnh sửa
            </button>

            <button className="history-pdf-button">
                ⬇ Xuất PDF
            </button>

            <button className="history-more-button">
                Khác ▼
            </button>
        </div>
    </div>

    {/* Tabs */}
    <div className="history-tabs-wrapper">
        <div 
        className={`history-tab-item ${
                    activeTab === "detail"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={khuDatDetailCloseBoundaryPage}

        >
            Thông tin chi tiết
        </div>

        <div 
        className={`history-tab-item ${
                    activeTab === "boundary"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={handleOpenMapPage}
        >
            Ranh giới & Bản đồ
        </div>

        <div 
        className={`history-tab-item ${
                    activeTab === "legal"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={handleShowLegal}
        >
            Pháp lý
        </div>

        <div 
         className={`history-tab-item ${
                    activeTab === "planning"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={handleShowPlanning}
        >
            Quy hoạch
        </div>

        <div 
          className={`history-tab-item ${
                    activeTab === "connect"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={handleShowConnect}
        >
            Hạ tầng & Kết nối
        </div>

        <div 
         className={`history-tab-item ${
                    activeTab === "businesses"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={handleShowBusinesses}
        >
            Doanh nghiệp thuê đất
        </div>

        <div 
        className={`history-tab-item ${
                    activeTab === "history"
                        ? "land-detail-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={handleShowHistory}
        
        >
            Lịch sử biến động
        </div>
    </div>

    {/* Timeline */}
    <div className="history-timeline-card">

        <div className="history-section-title">
            Dòng thời gian biến động
        </div>

        <div className="history-timeline-wrapper">

            {/* Item 1 */}
            <div className="history-timeline-item">
                <div className="history-timeline-icon history-green-icon">
                    📄
                </div>

                <div className="history-timeline-line"></div>

                <div className="history-timeline-date">
                    15/07/2020
                </div>

                <div className="history-timeline-title">
                    Quyết định giao đất
                </div>

                <div className="history-timeline-desc">
                    Giao đất cho Nhà nước để đầu tư hạ tầng KCN
                </div>
            </div>

            {/* Item 2 */}
            <div className="history-timeline-item">
                <div className="history-timeline-icon history-blue-icon">
                    ✎
                </div>

                <div className="history-timeline-line"></div>

                <div className="history-timeline-date">
                    28/07/2020
                </div>

                <div className="history-timeline-title">
                    Ký hợp đồng cho thuê
                </div>

                <div className="history-timeline-desc">
                    Ký HĐ thuê đất với Công ty TNHH An Giang Garment
                </div>
            </div>

            {/* Item 3 */}
            <div className="history-timeline-item">
                <div className="history-timeline-icon history-green-icon">
                    📄
                </div>

                <div className="history-timeline-line"></div>

                <div className="history-timeline-date">
                    14/07/2030
                </div>

                <div className="history-timeline-title">
                    Gia hạn thời hạn thuê
                </div>

                <div className="history-timeline-desc">
                    Gia hạn thời hạn thuê đất thêm 10 năm
                </div>
            </div>

            {/* Item 4 */}
            <div className="history-timeline-item">
                <div className="history-timeline-icon history-yellow-icon">
                    $
                </div>

                <div className="history-timeline-line"></div>

                <div className="history-timeline-date">
                    19/06/2032
                </div>

                <div className="history-timeline-title">
                    Điều chỉnh diện tích
                </div>

                <div className="history-timeline-desc">
                    Điều chỉnh diện tích thuê từ 45,00 ha còn 42,50 ha
                </div>
            </div>

            {/* Item 5 */}
            <div className="history-timeline-item">
                <div className="history-timeline-icon history-purple-icon">
                    •••
                </div>

                <div className="history-timeline-date">
                    10/10/2032
                </div>

                <div className="history-timeline-title">
                    Cập nhật biến động khác
                </div>

                <div className="history-timeline-desc">
                    Cập nhật biến động về hạ tầng, quy hoạch
                </div>
            </div>

        </div>
    </div>

    {/* Bottom Content */}
    <div className="history-bottom-wrapper">

        {/* Table */}
        <div className="history-table-card">

            <div className="history-table-header">
                <div className="history-section-title">
                    Danh sách biến động
                </div>

                <div className="history-table-actions">
                    <select className="history-filter-select">
                        <option>Tất cả loại biến động</option>
                    </select>

                    <div className="history-search-box">
                        <input
                            type="text"
                            placeholder="Tìm kiếm biến động..."
                            className="history-search-input"
                        />
                        <i className="fa-solid fa-magnifying-glass icon-history-magnifying"></i>
                    </div>
                </div>
            </div>

            <div className="history-table-responsive">

                <table className="history-data-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Ngày biến động</th>
                            <th>Loại biến động</th>
                            <th>Nội dung biến động</th>
                            <th>Cơ quan thực hiện</th>
                            <th>Số văn bản</th>
                            <th>Tệp đính kèm</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td>1</td>
                            <td>15/07/2020</td>
                            <td>Giao đất</td>
                            <td>
                                Quyết định giao đất để Nhà nước đầu tư xây dựng hạ tầng KCN Bình Hòa
                            </td>
                            <td>UBND tỉnh An Giang</td>
                            <td>1234/QĐ-UBND</td>
                            <td className="history-file-icon">
                                <i className="fa-regular fa-file-pdf"></i>
                            </td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>28/07/2020</td>
                            <td>Cho thuê đất</td>
                            <td>
                                Ký hợp đồng thuê đất với Công ty TNHH An Giang Garment
                            </td>
                            <td>Ban QL KKT An Giang</td>
                            <td>HĐTĐ-AG-2020-001</td>
                             <td className="history-file-icon">
                                <i className="fa-regular fa-file-pdf"></i>
                            </td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>09/03/2021</td>
                            <td>Điều chỉnh HĐ</td>
                            <td>
                                Điều chỉnh thời hạn thuê đất
                            </td>
                            <td>Ban QL KKT An Giang</td>
                            <td>2567/QĐ-UBND</td>
                            <td className="history-file-icon">
                                <i className="fa-regular fa-file-pdf"></i>
                            </td>
                        </tr>

                        <tr className="history-row-active">
                            <td>4</td>
                            <td>14/07/2030</td>
                            <td>Gia hạn thời hạn thuê</td>
                            <td>
                                Gia hạn thời hạn thuê đất thêm 10 năm (14/07/2030 - 14/07/2040)
                            </td>
                            <td>UBND tỉnh An Giang</td>
                            <td>789/GCN-UBND</td>
                            <td className="history-file-icon">
                                <i className="fa-regular fa-file-pdf"></i>
                            </td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>19/06/2032</td>
                            <td>Điều chỉnh diện tích</td>
                            <td>
                                Điều chỉnh diện tích thuê đất từ 45,00 ha còn 42,50 ha
                            </td>
                            <td>Ban QL KKT An Giang</td>
                            <td>987/QĐ-UBND</td>
                             <td className="history-file-icon">
                                <i className="fa-regular fa-file-pdf"></i>
                            </td>
                        </tr>

                        <tr>
                            <td>6</td>
                            <td>10/10/2032</td>
                            <td>Cập nhật khác</td>
                            <td>
                                Cập nhật biến động về hạ tầng, quy hoạch liên quan đến khu đất
                            </td>
                            <td>Ban QL KKT An Giang</td>
                            <td>CS 123456</td>
                             <td className="history-file-icon">
                                <i className="fa-regular fa-file-pdf"></i>
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>

            {/* Footer */}
            <div className="history-table-footer">

                <div className="history-table-count">
                    Hiển thị 1 - 6 trong tổng số 6 biến động
                </div>

                <div className="history-pagination-wrapper">

                    <select className="history-pagination-select">
                        <option>10 / trang</option>
                    </select>

                    <div className="history-pagination-buttons">

                        <button className="history-pagination-btn">
                            ‹
                        </button>

                        <button className="history-pagination-btn history-pagination-active">
                            1
                        </button>

                        <button className="history-pagination-btn">
                            ›
                        </button>

                    </div>

                </div>

            </div>

        </div>

        {/* Detail */}
        <div className="history-detail-card">

            <div className="history-section-title">
                Chi tiết biến động
            </div>
                <div className='history-detail-card-list'>

            <div className="history-detail-content">

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Loại biến động
                    </div>

                    <div className="history-detail-value history-status-green">
                        Gia hạn thời hạn thuê
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Ngày biến động
                    </div>

                    <div className="history-detail-value">
                        14/07/2030
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Nội dung
                    </div>

                    <div className="history-detail-value">
                        Gia hạn thời hạn thuê thêm 10 năm
                        (14/07/2030 - 14/07/2040)
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Diện tích
                    </div>

                    <div className="history-detail-value">
                        42,50 ha
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Cơ quan thực hiện
                    </div>

                    <div className="history-detail-value">
                        UBND tỉnh An Giang
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Số văn bản
                    </div>

                    <div className="history-detail-value">
                        789/GCN-UBND
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Ngày văn bản
                    </div>

                    <div className="history-detail-value">
                        14/07/2030
                    </div>
                </div>

                <div className="history-detail-group">
                    <div className="history-detail-label">
                        Ghi chú
                    </div>

                    <div className="history-detail-value">
                        -
                    </div>
                </div>

            </div>

            {/* Attachment */}
            <div className="history-attachment-wrapper">

                <div className="history-attachment-title">
                    Tệp đính kèm
                </div>

                <div className="history-attachment-item">

                    <div className="history-attachment-left">

                        <div className="history-pdf-icon">
                           <i className="fa-regular fa-file-pdf"></i>
                        </div>

                        <div>
                            <div className="history-attachment-file">
                                789_GCN_UBND.pdf
                            </div>

                            <div className="history-attachment-size">
                                1.25 MB
                            </div>
                        </div>

                    </div>

                    <button className="history-download-btn">
                        <i className="fa-solid fa-arrow-down"></i>
                    </button>

                </div>

            </div>
                </div>

        </div>

    </div>
</div>

      </div>
        {/* Lịch sử biến đông */}

















       
 














    </div>
        );
    }


export default DatDaiLand;